export default {
  password_show: 'Show password',
  password_hide: 'Hide password',
  settings_header: 'Settings',
  settings_section_account_security: 'Account and security',
  settings_email_address: 'Email address',
  settings_change_email: 'Change email',
  settings_change_password: 'Change password',
  settings_new_password: 'New password',
  settings_confirm_password: 'Confirm new password',
  settings_save_password: 'Save password',
  settings_saving: 'Saving...',
  settings_account_success_title: 'Updated',
  settings_account_error_title: 'Update failed',
  settings_email_updated: 'Your email address was changed successfully.',
  settings_email_verification_sent: 'A confirmation link was sent to the new email. Your account email will not change until you open the link and verify it.',
  settings_email_already_used: 'This email address is already used by another account.',
  settings_email_invalid: 'Enter a valid email address.',
  settings_password_updated: 'Your password was changed successfully.',
  settings_password_mismatch: 'The passwords do not match.',
  settings_password_too_short: 'The password must contain at least 6 characters.',
  settings_account_recent_login: 'For account security, sign out and sign in again before changing your email or password.',
  settings_account_update_failed: 'Could not update the account details.',
  settings_notifications_manage: 'Manage notifications and types',
  settings_section_theme: 'Appearance',
  settings_theme_light: 'Light mode',
  settings_theme_dark: 'Dark mode',
  settings_theme_system: 'System default',
  settings_toggle_theme_button: 'Switch theme now',
  settings_section_language: 'Language',
  settings_language_description: 'Choose the app interface language. More languages can be added later.',
  settings_language_option_ar: 'Arabic',
  settings_language_option_en: 'English',
  settings_section_direction: 'Layout direction',
  settings_direction_description: 'Choose the user interface direction. You can use auto or force RTL/LTR as preferred.',
  settings_direction_auto: 'Auto (based on language)',
  settings_direction_rtl: 'Right-to-left (RTL)',
  settings_direction_ltr: 'Left-to-right (LTR)',
  settings_section_notifications: 'Notifications',
  settings_notifications_description: 'Enable notifications to receive live updates from the app.',
  settings_notifications_note_windows: 'On Windows, notifications may arrive even if the browser is not visible. If the browser is closed or notifications are disabled in system settings, they will not arrive.',
  settings_windows_step_1: 'Long press the app icon on the home screen',
  settings_windows_step_2: 'Choose "App info"',
  settings_windows_step_3: 'Go to "Notifications"',
  settings_windows_step_4: 'Enable notifications',
  settings_check_notifications_button: 'Check activation',
  settings_notifications_enable_button: 'Enable notifications',
  settings_notifications_blocked_title: '⚠️ Notifications are blocked',
  settings_notifications_blocked_details: 'To re-enable notifications, follow these steps:',
  settings_notifications_disabled_note_blocked: '🚫 Notifications are blocked by the app and cannot be changed until you re-enable them from app settings',
  settings_notifications_disabled_note_not_enabled: '⚠️ Notifications are not enabled yet, but you can set your preferences in advance',
  settings_notification_types_label: 'Choose the notification types you want to receive:',
  settings_notification_type_mention_label: 'Mention notifications',
  settings_notification_type_mention_desc: 'When someone mentions you in a post or comment',
  settings_notification_type_reactions_label: 'Reaction notifications',
  settings_notification_type_reactions_desc: 'When someone reacts to your posts or comments',
  settings_notification_type_comments_label: 'Comment notifications',
  settings_notification_type_comments_desc: 'When someone comments on your posts',
  settings_notification_type_replies_label: 'Reply notifications',
  settings_notification_type_replies_desc: 'When someone replies to your comments',
  settings_notification_type_messages_label: 'Message notifications',
  settings_notification_type_messages_desc: 'When a private or group message arrives',
  settings_notification_type_bans_label: 'Ban notifications',
  settings_notification_type_bans_desc: 'When your content is banned or unbanned',
  settings_notif_saving_indicator: 'Saving...',
  settings_section_daily_plan: 'Daily plan',
  settings_daily_plan_desc: 'If you want to reset your daily plan questions, your current daily plan settings will be removed.',
  settings_reset_daily_plan_button: 'Reset daily plan questions',
  settings_reset_daily_plan_resetting: 'Resetting...',
  settings_section_legal_info: 'Legal information',
  settings_terms_of_service: 'Terms of service',
  settings_privacy_policy: 'Privacy policy',
  settings_child_safety: 'Child safety policy',
  settings_section_contact_us: 'Contact us',
  settings_contact_description: 'Have a question or suggestion? We are here to help.',
  settings_contact_email_label: 'support@amposter.com',
  settings_section_danger: 'Danger zone',
  settings_delete_account_warning: 'Deleting your account will permanently remove all your data and posts.',
  settings_delete_account_button: 'Delete account permanently',
  settings_delete_account_processing: 'Deleting...',
  settings_confirm_delete_title: 'Delete account permanently',
  settings_confirm_delete_message: 'Are you sure you want to delete your account? All your data and posts will be permanently removed and cannot be recovered.\n\n⚠️ Important warning: You will not be able to create a new account with the same email for 30 days.',
  settings_confirm_delete_confirm: 'Delete account',
  settings_confirm_cancel: 'Cancel',
  settings_confirm_reset_title: 'Reset daily plan questions',
  settings_confirm_reset_message: 'Do you want to delete the current daily plan preference data? Only user_prefs/{userId} will be removed.',
  settings_confirm_reset_confirm: 'Reset',
  settings_reset_success_title: 'Success',
  settings_reset_success_message: 'Daily plan questions have been reset successfully.',
  settings_error_title: 'Error',
  settings_error_no_user_message: 'User ID not found. Please log in again.',
  settings_error_reset_fail_message: 'Failed to reset daily plan questions. Please try again.',
  settings_error_delete_prefix: 'An error occurred while deleting the account:',
  settings_unknown_error: 'Unknown error',
  settings_deletion_overlay_title: 'Deleting account...',
  settings_deletion_warning: 'Do not close this page or press the back button',
  settings_deletion_step_fetch_posts: 'Fetching your posts data...',
  settings_deletion_step_deleting_posts: 'Deleting {count} posts...',
  settings_deletion_step_posts_deleted: '✅ All your posts have been deleted',
  settings_deletion_step_no_posts: '✅ No posts to delete',
  settings_deletion_step_deleting_role: 'Deleting user role...',
  settings_deletion_step_role_deleted: '✅ User role deleted',
  settings_deletion_step_deleting_points: 'Deleting points and currency...',
  settings_deletion_step_points_deleted: '✅ Points and currency deleted',
  settings_deletion_step_deleting_hashtags: 'Deleting hashtags...',
  settings_deletion_step_hashtags_deleted: '✅ Hashtags deleted',
  settings_deletion_step_deleting_quran_progress: 'Deleting Quran progress...',
  settings_deletion_step_quran_progress_deleted: '✅ Quran progress deleted',
  settings_deletion_step_deleting_quran_status: 'Deleting Quran status...',
  settings_deletion_step_quran_status_deleted: '✅ Quran status deleted',
  settings_deletion_step_deleting_notifications: 'Deleting notifications...',
  settings_deletion_step_notifications_deleted: '✅ Notifications deleted',
  settings_deletion_step_deleting_suggestions: 'Deleting suggestion reports...',
  settings_deletion_step_suggestions_deleted: '✅ Suggestion reports deleted',
  settings_deletion_step_deleting_deleted_records: 'Deleting deleted post records...',
  settings_deletion_step_deleted_records_deleted: '✅ Deleted post records removed',
  settings_deletion_step_deleting_videos: 'Deleting videos...',
  settings_deletion_step_videos_deleted: '✅ Videos deleted',
  settings_deletion_step_deleting_team_posts: 'Deleting team posts...',
  settings_deletion_step_team_posts_deleted: '✅ Team posts deleted',
  settings_deletion_step_deleting_profile: 'Deleting profile data...',
  settings_deletion_step_profile_deleted: '✅ Profile data deleted',
  settings_deletion_step_removing_appstatus: 'Removing AppStatus entry...',
  settings_deletion_step_appstatus_removed: '✅ AppStatus entry removed',
  settings_deletion_step_deleting_auth: 'Deleting authentication account...',
  settings_deletion_step_auth_deleted: '✅ Authentication account deleted',
  settings_deletion_step_logged_out_after_delete: '✅ Logged out',
  settings_deletion_step_cleanup_cache: 'Cleaning local data and cache...',
  settings_deletion_step_cleanup_done: '✅ Local data and cache cleaned',
  settings_deletion_step_delete_success: '✨ Your account has been deleted successfully!',
  settings_deletion_step_logout_warning: '⚠️ Logged out (account deletion requires recent login to delete)',
  settings_deletion_step_logout_partial: '⚠️ Logged out (authentication account was not deleted)',
  profile_menu_loading: 'Loading...',
  profile_menu_feature_dev_message: '{feature} is under development',
  profile_menu_profile_image_alt: 'Profile image',
  profile_menu_unknown: 'Unknown',
  profile_menu_unknown_tag: 'Unknown',
  profile_menu_inventory: 'My inventory',
  bottom_nav_unread_notifications: 'Unread notifications',
  profile_menu_view_profile: 'View profile',
  profile_menu_notifications: 'Notifications',
  profile_menu_team: 'Team',
  profile_menu_games: 'Games',
  profile_menu_friend_requests: 'Contacts',
  profile_menu_messages: 'Messages',
  profile_menu_store: 'Store',
  profile_menu_wallet: 'Wallet',
  profile_menu_plugins: 'Plugins',
  profile_menu_plugins_description: 'Choose which optional shortcuts appear in your profile menu.',
  profile_menu_create_event: 'Create event',
  profile_menu_quran: 'Quran',
  profile_menu_characters: 'Islamic characters',
  profile_menu_tasbeeh: 'Azkar challenge',
  profile_menu_prayer_tracker: 'Prayer tracker',
  profile_menu_adhkar: 'Morning and evening Azkar',
  profile_menu_create_plan: 'Create today plan',
  profile_menu_saraha: 'Saraha',
  profile_menu_currency_log: 'Currency log',
  profile_menu_daily_quiz: 'Daily quiz',
  profile_menu_reports_box: 'Reports box',
  profile_menu_my_hashtags: 'My hashtags',
  profile_menu_saved_posts: 'Saved posts',
  profile_menu_drafts: 'Drafts',
  profile_menu_events: 'Events',
  profile_menu_settings: 'Settings',
  profile_menu_staff: 'Staff',
  profile_menu_moderation_log: 'Moderation log',
  profile_menu_create_daily_question: 'Create daily question',
  profile_menu_deleted_posts: 'Deleted posts',
  profile_menu_logs_section: 'Logs',
  profile_menu_suggestions_box: 'Suggestions',
  profile_menu_unified_reports_system: 'Reports',
  profile_menu_admin_section: 'Administration',
  profile_menu_switch_account: 'Switch account',
  profile_menu_logout: 'Logout',
  profile_menu_switch_error_generic: 'Unable to open account switcher. Please try again.',
  profile_menu_switch_session_expired: "This account's session has expired. Please sign in again.",
  profile_menu_logout_switch_message: 'Logging out of this account will remove it from this device. Do you want to continue?',
  profile_menu_add_account: 'Add account',
  profile_menu_main_account: 'Main account',
  islamic_hub_title: 'Islamic',
  islamic_hub_subtitle: 'Your daily space to grow closer to Allah',
  islamic_hub_desc_adhkar: 'Start and close your day remembering Allah',
  islamic_hub_desc_tasbeeh: 'Challenge yourself and earn daily badges',
  islamic_hub_desc_prayer_tracker: 'Track your prayers and stay consistent',
  islamic_hub_desc_characters: 'Learn the stories of companions and scholars',
  islamic_hub_desc_quran: 'Read and memorize the verses of the Quran',
  bottom_nav_home: 'Home',
  bottom_nav_missions: 'Badges',
  bottom_nav_create_post: 'Create post',
  bottom_nav_create_newspaper: 'Create newspaper',
  bottom_nav_drafts: 'Drafts',
  bottom_nav_create_poll: 'Create poll',
  bottom_nav_create_quiz: 'Create quiz',
  bottom_nav_create_video: 'Create short video (Reels)',
  bottom_nav_team: 'Islamic',
  bottom_nav_more: 'More',
  settings_section_bottom_navbar_direction: 'Bottom navigation direction',
  settings_bottom_navbar_direction_description: 'Set the bottom navigation bar direction independently from the rest of the app.',

  // LoginPage.js
  login_language_toggle_aria: 'Toggle language',
  login_logo_alt: 'App logo',
  login_welcome: 'Welcome back!',
  login_email_divider: 'Or use email',
  login_email_placeholder: 'you@domain.com',
  login_password_placeholder: 'Password',
  login_confirm_password_placeholder: 'Confirm password',
  login_terms_intro: 'By continuing, you agree to',
  login_terms_link: 'Terms of service',
  login_privacy_link: 'Privacy policy',
  login_signin_button: 'Sign in',
  login_signing_in: 'Signing in...',
  login_signup_button: 'Create account',
  login_creating_account: 'Creating account...',
  login_forgot_password: 'Forgot password?',
  login_sending_reset: 'Sending reset link...',
  login_install_button: 'Install app',
  login_resend_verification: 'Resend verification email',
  login_no_account: 'Don’t have an account?',
  login_have_account: 'Already have an account?',
  login_signup_link: 'Create account',
  login_signin_link: 'Sign in',
  login_error_email_password_required: 'Please enter email and password',
  login_error_password_mismatch: 'Passwords do not match',
  login_error_password_min_length: 'Password must be at least {min} characters',
  login_error_password_max_length: 'Password must not exceed {max} characters',
  login_error_password_blank: 'Password cannot contain only spaces',
  login_password_requirements: 'Password requirements',
  login_password_requirement_met: 'Requirement met',
  login_password_requirement_unmet: 'Requirement not met',
  login_password_requirement_length: '{min}–{max} characters',
  login_password_requirements_note: 'An uppercase letter, number or special character is not required.',
  login_password_confirmation_required: 'Confirmation must match your password',
  login_password_confirmation_matched: 'Passwords match',
  login_info_verification_sent: '📧 Verification link has been sent to your email. Check spam if you do not see it.',
  login_verification_dialog_title: 'Check your email',
  login_verification_dialog_confirm: 'Got it',
  login_verification_dialog_close: 'Close dialog',
  login_error_email_in_use: 'Email is already in use',
  login_error_invalid_email: 'Invalid email address',
  login_error_signup_failed: 'Failed to create account',
  login_error_verify_email: 'Please verify your email first',
  login_error_user_not_found: 'Email is not registered',
  login_error_wrong_password: 'Incorrect password',
  login_error_reset_email_required: 'Enter your email address to reset your password',
  login_info_password_reset_sent: 'Your request was received. If this email belongs to an account eligible for recovery, you will receive a password reset link. It may take a few minutes; check your spam folder too.',
  login_password_reset_dialog_title: 'Check your email',
  login_password_reset_email_label: 'Email you entered',
  login_password_reset_error_title: 'Could not send the reset link',
  login_password_reset_not_found_title: 'Account not found',
  login_password_reset_not_found_message: 'No account was found with this email address. Check the spelling and try again.',
  login_password_reset_edit_email: 'Correct email address',
  login_error_password_reset_unavailable: 'Email delivery is currently unavailable. Please try again later.',
  login_password_reset_google_title: 'Use Google sign-in',
  login_password_reset_google_message: 'This email uses Google sign-in, so there is no password to reset. Use Continue with Google.',
  login_error_password_reset_failed: 'Could not send the password reset email. Please try again.',
  login_error_verification_resend_failed: 'Could not resend the verification email. Please try signing in again.',
  login_error_user_disabled: 'This account has been disabled. Contact support for help.',
  login_error_too_many_requests: 'Too many attempts. Please wait a little and try again.',
  login_error_network: 'Unable to connect. Check your internet connection and try again.',
  login_add_account_title: 'Add account',
  login_add_account_subtitle: 'Sign in to add another account to this device',
  login_add_account_cancel: 'Cancel',
  login_error_signin_failed: 'Failed to sign in',
  login_error_google_failed: 'Google sign-in failed',
  login_info_verification_resent: '📧 Verification email resent. Check spam if you do not see it.',

  // ProfileModal.jsx
  profile_modal_title: 'Profile',

  // Profile.jsx
  profile_loading: 'Loading user data...',
  profile_user_not_found: 'User not found',
  profile_user_not_found_desc: 'The link you are looking for is incorrect or the user has been deleted.',
  profile_go_back: 'Go back',
  profile_logout_confirm_title: 'Confirm logout',
  profile_logout_confirm_message: 'Do you want to log out of your account?',
  profile_logout_confirm_btn: 'Yes, log out',
  profile_logout_error_message: 'An error occurred while logging out',
  profile_copy_link: 'Copy profile link',
  profile_copied_title: 'Copied',
  profile_copy_link_success: 'Profile link copied',
  profile_copy_user_id: 'Copy user ID',
  profile_copy_id_success: 'User ID copied successfully',
  profile_view_user_info: 'View user info',
  profile_view_activity: 'View activity stats',
  profile_user_notes: 'User notes',
  profile_add_note: 'Add note',
  profile_edit_note: 'Edit note',
  profile_delete_note: 'Delete note',
  profile_note_placeholder: 'Write an internal note about this user...',
  profile_note_save: 'Save note',
  profile_note_cancel: 'Cancel',
  profile_no_notes: 'No notes yet for this user',
  profile_notes_load_error: 'An error occurred while loading notes',
  profile_note_added: 'Note added successfully',
  profile_note_updated: 'Note updated successfully',
  profile_note_deleted: 'Note deleted successfully',
  profile_note_save_error: 'An error occurred while saving the note',
  profile_note_delete_error: 'An error occurred while deleting the note',
  profile_note_empty_error: 'Please write a note before saving',
  profile_note_permission_error: "You don't have permission to view or manage this user's notes",
  profile_note_delete_confirm_title: 'Delete note',
  profile_note_delete_confirm_message: 'Are you sure you want to delete this note? This cannot be undone.',
  profile_note_author: 'Author',
  profile_note_updated_at: 'Last updated',
  profile_note_type_positive: 'Positive',
  profile_note_type_negative: 'Negative',
  profile_note_type_neutral: 'Neutral',
  profile_can_participate_events: 'Can participate in events',
  profile_can_participate_events_desc: 'Controls whether this user is allowed to join events',
  profile_cannot_participate_events: 'Cannot participate in events',
  profile_allow_image: 'Allow image',
  profile_ban_image: 'Ban image',
  profile_allow_cover: 'Allow cover',
  profile_ban_cover: 'Ban cover',
  profile_send_warning: 'Send warning',
  profile_ban_publish: 'Ban publishing',
  profile_ban_comment: 'Ban commenting',
  profile_ban_reaction: 'Ban reactions',
  profile_ban_message: 'Ban messaging',
  profile_ban_permanent: 'General ban',
  profile_moderation_actions: 'Blocking actions',
  profile_unban_publish: 'Unban publishing',
  profile_unban_comment: 'Unban commenting',
  profile_unban_reaction: 'Unban reactions',
  profile_unban_message: 'Unban messaging',
  profile_unban_permanent: 'Remove general ban',
  profile_grant_title: 'Grant title',
  profile_grant_badge: 'Grant badge',
  profile_add_to_staff: 'Add to staff',
  profile_delete_title: 'Delete title',
  profile_delete_badge: 'Delete badge',
  profile_choose_frame: 'Choose frame',
  profile_edit_profile: 'Edit profile',
  profile_follow: 'Follow',
  profile_unfollow: 'Unfollow',
  profile_follows_you: 'Follows you',
  profile_join_date: 'Joined',
  profile_followers: 'Followers',
  profile_following: 'Following',
  profile_insufficient_balance: 'Your balance is insufficient to complete the operation',
  profile_tab_latest: 'Latest posts',
  profile_tab_lists: 'Post lists',
  profile_loading_more: 'Loading more...',
  profile_loading_posts: 'Loading posts...',
  profile_no_posts: 'No posts yet',
  profile_list_untitled: 'Untitled list',
  profile_post_count_unit: 'posts',
  profile_no_lists: 'No post lists yet',
  profile_no_lists_hint: 'Tap the + button to create your first list',
  profile_cancel: 'Cancel',
  profile_save: 'Save',
  profile_delete: 'Delete',
  profile_close: 'Close',
  profile_error_title: 'Error',
  profile_success_title: 'Success',
  profile_updated_title: 'Updated',
  profile_sent_title: 'Sent',
  profile_reported_title: 'Reported',
  profile_unknown: 'Unknown',
  profile_this_user: 'this user',
  profile_send_btn: 'Send',
  profile_update_error: 'An error occurred while updating the data',
  profile_image_banned: 'User image has been banned',
  profile_image_allowed: 'User image has been allowed',
  profile_cover_banned: 'User cover has been banned',
  profile_cover_allowed: 'User cover has been allowed',
  profile_send_warning_title: 'Send warning',
  profile_send_warning_message: 'Do you want to send a warning to {name}?',
  profile_warning_sent_success: 'Warning sent successfully',
  profile_warning_sent_error: 'An error occurred while sending the warning',
  profile_already_reported_image: 'You have already reported this image',
  profile_already_reported_cover: 'You have already reported this cover',
  profile_report_success: 'Report sent successfully',
  profile_report_error: 'An error occurred while sending the report',
  profile_title_name_required: 'Please enter a title name',
  profile_title_granted_success: 'Title granted successfully',
  profile_title_granted_error: 'An error occurred while granting the title',
  profile_title_deleted_success: 'Title deleted successfully',
  profile_title_deleted_error: 'An error occurred while deleting the title',
  profile_title_select_required: 'Please select a title to delete',
  profile_badge_select_required: 'Please select a badge',
  profile_badge_name_required: 'Please enter a badge name',
  profile_badge_granted_success: 'Badge granted successfully',
  profile_badge_granted_error: 'An error occurred while granting the badge',
  profile_badge_deleted_success: 'Badge deleted successfully',
  profile_badge_deleted_error: 'An error occurred while deleting the badge',
  profile_staff_added_success: 'User added to staff with unassigned role',
  profile_staff_added_error: 'An error occurred while adding the user to staff',
  profile_ban_save_error: 'An error occurred while saving the ban',
  profile_ban_success: '{banLabel} applied successfully',
  profile_unban_success: '{banLabel} removed successfully',
  profile_ban_generic: 'Ban',
  profile_grant_title_dialog_heading: 'Grant title',
  profile_title_name_label: 'Title name',
  profile_title_name_placeholder: 'Enter title name',
  profile_duration_label: 'Duration',
  profile_duration_1day: 'One day',
  profile_duration_3days: '3 days',
  profile_duration_month: 'One month',
  profile_duration_permanent: 'Permanent',
  profile_bg_color_label: 'Background color',
  profile_text_color_label: 'Text color',
  profile_preview_label: 'Preview',
  profile_preview_placeholder: 'Title preview',
  profile_delete_title_dialog_heading: 'Delete title',
  profile_select_title_to_delete: 'Select a title to delete',
  profile_select_title_placeholder: '-- Select a title --',
  profile_grant_badge_dialog_heading: 'Grant badge',
  profile_badge_name_label: 'Badge name',
  profile_badge_name_placeholder: 'Enter badge name',
  profile_select_badge_label: 'Select a badge',
  profile_delete_badge_dialog_heading: 'Delete badge',
  profile_select_badge_to_delete: 'Select a badge to delete',
  profile_select_badge_placeholder: '-- Select a badge --',
  profile_ban_target_label: 'Target user',
  profile_ban_type_label: 'Ban type',
  profile_ban_duration_label: 'Ban duration',
  profile_ban_temporary: 'Temporary',
  profile_ban_amount_label: 'Amount',
  profile_ban_unit_label: 'Unit',
  profile_ban_unit_days: 'Days',
  profile_ban_unit_months: 'Months',
  profile_ban_reason_label: 'Reason',
  profile_ban_reason_placeholder: 'Enter ban reason',
  profile_unban_confirm_text: '{banLabel} will be removed from this user.',
  profile_ban_current_reason: 'Current reason',
  profile_unban_confirm_btn: 'Remove ban',
  profile_unban_dialog_heading: 'Remove {banLabel}',
  profile_user_info_heading: 'User information',
  profile_info_name: 'Name',
  profile_info_username: 'Username',
  profile_info_email: 'Email',
  profile_info_currency: 'Currency count',
  profile_info_currency_unit: 'coins',
  profile_info_points: 'Points',
  profile_info_points_unit: 'points',
  profile_info_violations: 'Violations',
  profile_info_violations_unit: 'violations',
  profile_info_saraha_sent: 'Saraha messages sent',
  profile_info_messages_unit: 'messages',
  profile_info_team: 'Team',
  profile_info_no_team: 'Not part of any team',
  profile_info_morning_streak: 'Morning Azkar streak',
  profile_info_evening_streak: 'Evening Azkar streak',
  profile_info_tasbeeh_streak: 'Tasbeeh streak',
  profile_info_days_unit: 'days',
  profile_info_join_date: 'Join date',
  profile_info_unavailable: 'Not available',
  profile_back_tooltip: 'Go back',
  profile_logout_tooltip: 'Log out',
  profile_options_tooltip: 'Options',
  profile_drag_list_tooltip: 'Drag list',
  profile_coins_sent_to_ar: 'Sent coins to: {name}',
  profile_coins_sent_to_ltr: 'Sent coins to: {name}',
  profile_coins_received_from_ar: 'Received coins from: {name}',
  profile_coins_received_from_ltr: 'Received coins from: {name}',

  // CreateProfilePage.jsx
  create_profile_header: 'Create profile',
  create_profile_uploading_image: 'Uploading image...',
  create_profile_creating_profile: 'Creating profile...',
  create_profile_wait_message: 'Please wait and do not close the page',
  create_profile_timeout_warning: '⚠️ The connection is slow. You can continue and change your data later from profile settings',
  create_profile_image_alt: 'Profile image',
  create_profile_name_placeholder: 'Name',
  create_profile_finding_tag: 'Finding an available tag...',
  create_profile_tag_placeholder: 'User tag',
  create_profile_refresh_tag_title: 'Generate another random tag',
  create_profile_tag_helper: 'You can change it or keep the suggested tag — it must be unique (at least 3 characters)',
  create_profile_description_placeholder: 'Write a short description about yourself',
  create_profile_checking: 'Checking...',
  create_profile_saving: 'Saving...',
  create_profile_create_button: 'Create profile',
  create_profile_crop_title: 'Crop image',
  create_profile_crop_desc: 'Move and zoom the image to choose the desired area',
  create_profile_zoom_label: 'Zoom',
  create_profile_crop_cancel: 'Cancel crop',
  create_profile_crop_apply: 'Apply crop',
  create_profile_signin_wait_title: 'Signing in',
  create_profile_signin_wait_message: 'Please wait until database sign-in is complete, then try again',

  // HomePosts.jsx
  home_tab_following: 'Following',
  home_tab_events: 'Events',
  home_tab_latest: 'Latest Posts',
  home_loading_posts: 'Loading posts...',
  home_loading_more: 'Loading more...',
  home_no_events: 'No events yet',
  home_no_following_posts: 'No posts from people you follow',
  home_end_of_feed: 'You have reached the end',
  home_status_fab_tooltip: 'What is happening now?',
  home_search: 'Search',
  home_filter_all: 'All',
  home_filter_newspapers: 'Newspapers',
  home_filter_videos: 'Videos',
  home_filter_blogs: 'Posts',
  home_filter_winners: 'Winners',
  home_filter_articles: 'Articles',
  home_filter_polls: 'Polls',
  home_filter_quizzes: 'Quizzes',
  home_filter_highlights: 'Highlights',
  home_no_filtered_posts: 'No posts of this type yet',

  // PostCard.jsx
  postcard_ad_cancelled: 'Advertisement cancelled',
  postcard_already_reported_message: 'You have already reported this post',
  postcard_already_reported_title: 'Already reported',
  postcard_banned_reaction_message: 'You are banned from reacting and cannot send reactions.',
  postcard_banned_title: 'Banned',
  postcard_block: 'Block',
  postcard_block_post_message: 'Are you sure you want to block this post for violating app rules?',
  postcard_block_post_title: 'Block post',
  postcard_blocked_message: 'This post is blocked - violates app rules 🚫',
  postcard_cancel: 'Cancel',
  postcard_cancel_ad: 'Cancel advertisement',
  postcard_cancel_ad_message: 'Do you want to stop making this post an advertisement?',
  postcard_cancel_ad_title: 'Cancel advertisement',
  postcard_cannot_edit_message: 'This post cannot be edited because it was blocked by administration',
  postcard_cannot_edit_title: 'Cannot edit post',
  postcard_close: 'Close',
  postcard_coin_alt: 'coin',
  postcard_comments: 'Comments',
  postcard_convert_to_ad: 'Convert to ad',
  postcard_convert_to_ad_message: 'Do you want to make this post a featured advertisement?',
  postcard_convert_to_ad_title: 'Convert to ad',
  postcard_converted_to_ad: 'Post converted to advertisement',
  postcard_copied_title: 'Copied',
  postcard_copy_link_failed: 'Failed to copy link',
  postcard_cover_alt: 'Cover',
  postcard_delete: 'Delete',
  postcard_delete_post_message: 'Are you sure you want to delete this post?',
  postcard_delete_post_title: 'Delete post',
  postcard_done: 'Done',
  postcard_error_title: 'Error',
  postcard_frame_alt: 'Frame',
  postcard_hide: 'Hide',
  postcard_hide_post_message: 'Are you sure you want to hide this post?',
  postcard_hide_post_title: 'Hide post',
  postcard_ok: 'OK',
  postcard_pin: 'Pin',
  postcard_pin_message: 'Do you want to pin this post?',
  postcard_pin_title: 'Pin post',
  postcard_post_blocked: 'Post blocked',
  postcard_post_link_copied: 'Post link copied successfully',
  postcard_post_pinned: 'Post pinned',
  postcard_post_removed_from_saved: 'Post removed from saved items',
  postcard_post_saved: 'Post saved',
  postcard_post_title: 'Post',
  postcard_post_unblocked: 'Post unblocked',
  postcard_post_unpinned: 'Post unpinned',
  postcard_profile_image_alt: 'Profile picture',
  postcard_reaction_angry: 'Angered me',
  postcard_reaction_care: 'Keep going',
  postcard_reaction_haha: 'Haha',
  postcard_reaction_like: 'Useful',
  postcard_reaction_love: 'Brilliant',
  postcard_reaction_sad: 'Saddened me',
  postcard_reaction_wow: 'Wow',
  postcard_reactions_closed_message: 'The post owner has closed reactions on this post',
  postcard_reactions_closed_title: 'Reactions closed',
  postcard_read_more: 'Read more',
  postcard_remove: 'Remove',
  postcard_remove_from_events_message: 'Do you want to remove this post from events?',
  postcard_remove_from_events_title: 'Remove from events',
  postcard_remove_from_list_message: 'Are you sure you want to remove this post from the list?',
  postcard_remove_from_list_title: 'Remove from list',
  postcard_removed_from_events_success: 'Post removed from events',
  postcard_removed_from_list_message: 'Post removed from the list successfully! The page will refresh.',
  postcard_removed_title: 'Removed',
  postcard_report: 'Report',
  postcard_report_post_message: 'Are you sure you want to report this post?',
  postcard_report_post_title: 'Report post',
  postcard_reported_message: 'Post reported successfully',
  postcard_reported_title: 'Reported',
  postcard_set: 'Set',
  postcard_set_as_event_message: 'Do you want to set this post as an event?',
  postcard_set_as_event_success: 'Post set as an event',
  postcard_set_as_event_title: 'Set as event post',
  postcard_share_text: 'Check out this post',
  postcard_show_more: 'Show more',
  postcard_surah_label: 'Surah',
  postcard_unblock: 'Unblock',
  postcard_unblock_post_message: 'Are you sure you want to unblock this post?',
  postcard_unblock_post_title: 'Unblock post',
  postcard_unhide: 'Unhide',
  postcard_unhide_post_message: 'Are you sure you want to unhide this post?',
  postcard_unknown_user: 'Unknown user',
  postcard_unpin: 'Unpin',
  postcard_unpin_message: 'Do you want to unpin this post?',
  postcard_unpin_title: 'Unpin post',
  postcard_verified_alt: 'verified',
  postcard_video_link_copied: 'Video link copied successfully',
  postcard_viewing_as_moderator: 'You are viewing this content because you are a moderator',
  postcard_yes: 'Yes',

  // UnifiedPostMenu.jsx
  unified_post_menu_done: 'Done',
  unified_post_menu_error: 'Error',
  unified_post_menu_warning: 'Warning',
  unified_post_menu_cancel: 'Cancel',
  unified_post_menu_not_available: 'Not available',
  unified_post_menu_copied_title: 'Copied',
  unified_post_menu_reported_title: 'Reported',

  // Edit
  unified_post_menu_edit_post: 'Edit post',

  // Save
  unified_post_menu_save_post: 'Save post',
  unified_post_menu_remove_from_saved: 'Remove from saved',
  unified_post_menu_post_saved: 'Post saved',
  unified_post_menu_post_removed_from_saved: 'Post removed from saved items',
  unified_post_menu_save_error: 'An error occurred while saving the post',

  // Copy link
  unified_post_menu_copy_link: 'Copy link',
  unified_post_menu_link_copied: 'Link copied',
  unified_post_menu_copy_link_failed: 'Failed to copy link',

  // Add / remove from list
  unified_post_menu_add_to_list: 'Add to list',
  unified_post_menu_remove_from_list: 'Remove from list',
  unified_post_menu_add_to_list_unavailable: 'Adding post to a list is not available right now',
  unified_post_menu_remove_from_list_unavailable: 'Removing post from list is not available right now',

  // Comments
  unified_post_menu_open_comments: 'Open comments',
  unified_post_menu_close_comments: 'Close comments',
  unified_post_menu_enable_comments: 'allow comments',
  unified_post_menu_disable_comments: 'disable comments',
  unified_post_menu_toggle_comments_message: 'Do you want to {action} on this post?',
  unified_post_menu_comments_opened: 'Comments have been enabled',
  unified_post_menu_comments_closed: 'Comments have been closed',
  unified_post_menu_toggle_comments_error: 'An error occurred while updating comments',

  // Reactions
  unified_post_menu_open_reactions: 'Open reactions',
  unified_post_menu_close_reactions: 'Close reactions',
  unified_post_menu_enable_reactions: 'allow reactions',
  unified_post_menu_disable_reactions: 'disable reactions',
  unified_post_menu_toggle_reactions_message: 'Do you want to {action} on this post?',
  unified_post_menu_reactions_opened: 'Reactions have been enabled',
  unified_post_menu_reactions_closed: 'Reactions have been closed',
  unified_post_menu_toggle_reactions_error: 'An error occurred while updating reactions',

  // Pin
  unified_post_menu_pin_post: 'Pin post',
  unified_post_menu_unpin: 'Unpin',
  unified_post_menu_pin_message: 'Do you want to pin this post to your profile?',
  unified_post_menu_unpin_message: 'Do you want to remove the pin?',
  unified_post_menu_post_pinned: 'Post pinned',
  unified_post_menu_post_unpinned: 'Post unpinned',
  unified_post_menu_toggle_pin_error: 'An error occurred while updating the pin',

  // Event (main post)
  unified_post_menu_set_as_event: 'Set as event',
  unified_post_menu_remove_from_events: 'Remove from events',
  unified_post_menu_set_as_event_message: 'Do you want to set this post as an event?',
  unified_post_menu_remove_from_events_message: 'Do you want to remove this post from events?',
  unified_post_menu_post_set_as_event: 'Post set as an event',
  unified_post_menu_post_removed_from_events: 'Post removed from events',
  unified_post_menu_toggle_event_error: 'An error occurred while updating the event',

  // Advertisement
  unified_post_menu_convert_to_ad: 'Convert to featured ad',
  unified_post_menu_cancel_ad: 'Cancel advertisement',
  unified_post_menu_convert_to_ad_message: 'Do you want to convert this post to a featured advertisement?',
  unified_post_menu_cancel_ad_message: 'Do you want to cancel the advertisement?',
  unified_post_menu_post_converted_to_ad: 'Post converted to advertisement',
  unified_post_menu_ad_cancelled: 'Advertisement cancelled',
  unified_post_menu_toggle_ad_error: 'An error occurred while updating the advertisement',

  // Delete
  unified_post_menu_delete_post: 'Delete post',
  unified_post_menu_delete_post_message: 'The post will be moved to trash. Are you sure?',
  unified_post_menu_delete_post_error: 'An error occurred while deleting the post',

  // Block
  unified_post_menu_block_post: 'Block post',
  unified_post_menu_unblock_post: 'Unblock post',
  unified_post_menu_block_post_message: 'Do you want to block this post for violating the rules?',
  unified_post_menu_unblock_post_message: 'Do you want to unblock this post?',
  unified_post_menu_post_blocked: 'Post blocked',
  unified_post_menu_post_unblocked: 'Post unblocked',
  unified_post_menu_block_notification: 'Your post has been blocked for violating the rules',
  unified_post_menu_unblock_notification: 'The block on your post has been lifted',
  unified_post_menu_toggle_block_error: 'An error occurred while updating the block',

  // Hide from feed
  unified_post_menu_hide_from_feed: 'Hide from latest posts',
  unified_post_menu_show_in_feed: 'Show in latest posts',
  unified_post_menu_hide_from_feed_message: 'Do you want to hide this post from latest posts? It will still be visible on the profile page.',
  unified_post_menu_show_in_feed_message: 'Do you want to show this post again in latest posts for everyone?',
  unified_post_menu_post_hidden_from_feed: 'Post hidden from latest posts',
  unified_post_menu_post_shown_in_feed: 'Post shown in latest posts',
  unified_post_menu_toggle_hide_from_feed_error: 'An error occurred while updating the post',

  // Report
  unified_post_menu_report_content: 'Report content',
  unified_post_menu_report_dialog_heading: 'Report content',
  unified_post_menu_report_dialog_subtitle: 'Write the details you want to deliver',
  unified_post_menu_report_details_label: 'Report details',
  unified_post_menu_report_details_placeholder: 'Example: this post is offensive, or this reply contains a threat...',
  unified_post_menu_report_details_required: 'Please write the report details first',
  unified_post_menu_report_sent_message: 'Report sent successfully and will be reviewed',
  unified_post_menu_send_report: 'Send report',
  unified_post_menu_report_error: 'An error occurred while sending the report',

  // PostCommentsModal.jsx (pcm_*)
  pcm_reaction_like: 'Useful',
  pcm_reaction_love: 'Brilliant',
  pcm_reaction_care: 'Keep going',
  pcm_reaction_haha: 'Haha',
  pcm_reaction_wow: 'Wow',
  pcm_reaction_sad: 'Saddened me',
  pcm_reaction_angry: 'Angered me',
  pcm_reactions_closed_title: 'Reactions closed',
  pcm_reactions_closed_message: 'The post owner has closed reactions on this post',
  pcm_login_required_title: 'Login required',
  pcm_login_required_to_react: 'Please log in to react',
  pcm_comment_deleted: 'Comment deleted',
  pcm_surah_label: 'Surah',
  pcm_banned_title: 'Banned',
  pcm_banned_comment_message: 'You are banned from commenting and cannot post a comment.',
  pcm_login_required_before_comment: 'Please log in before adding a comment',
  pcm_insufficient_coins_title: 'Insufficient coins',
  pcm_insufficient_coins_message: 'You do not have enough balance to send these amounts with the comment',
  pcm_post_deleted: 'Post deleted',
  pcm_error_title: 'Error',
  pcm_error_post_owner_missing: 'An error occurred: post owner not found',
  pcm_coins_transfer_error: 'An error occurred while transferring coins. No amount was deducted.',
  pcm_block_police: 'Comment blocked - security violation 👮',
  pcm_block_health: 'Comment blocked - health violation 🏥',
  pcm_block_literature: 'Comment blocked - conduct violation 📚',
  pcm_block_law: 'Comment blocked - legal violation ⚖️',
  pcm_block_admin: 'Comment blocked - administrative decision 🔒',
  pcm_blocked_generic: 'Comment blocked',
  pcm_login_required_action: 'Please log in to perform this action',
  pcm_already_reported_title: 'Already reported',
  pcm_already_reported_message: 'You have already reported this comment',
  pcm_report_police_title: 'Report to Police Center',
  pcm_report_police_message: 'Are you sure you want to report this comment to the Police Center?',
  pcm_login_required_to_report: 'Please log in to complete the report',
  pcm_report_police_theft_reason: 'Police Center report for theft',
  pcm_reported_title: 'Reported',
  pcm_report_police_success: 'The comment has been successfully reported to the Police Center',
  pcm_report_error: 'An error occurred while reporting',
  pcm_report_health_title: 'Report to Health Center',
  pcm_report_health_message: 'Are you sure you want to report this comment to the Health Center?',
  pcm_report_health_depression_reason: 'Health Center report for depression',
  pcm_report_health_success: 'The comment has been successfully reported to the Health Center',
  pcm_report_literature_title: 'Report to Conduct Center',
  pcm_report_literature_message: 'Are you sure you want to report this comment to the Conduct Center?',
  pcm_report_literature_abuse_reason: 'Conduct Center report for abuse',
  pcm_report_literature_success: 'The comment has been successfully reported to the Conduct Center',
  pcm_report_law_title: 'Report to Law Center',
  pcm_report_law_message: 'Are you sure you want to report this comment to the Law Center?',
  pcm_report_law_violation_reason: 'Law Center report for legal violation',
  pcm_report_law_success: 'The comment has been successfully reported to the Law Center',
  pcm_login_required_for_report: 'You must be logged in to report',
  pcm_report_submit_success: 'Report submitted successfully. Thank you for helping keep the community safe.',
  pcm_report_submit_error: 'An error occurred while submitting the report. Please try again later.',
  pcm_delete_comment_title: 'Delete comment',
  pcm_delete_comment_message: 'Are you sure you want to delete this comment? This action cannot be undone.',
  pcm_delete_btn: 'Delete',
  pcm_cancel_btn: 'Cancel',
  pcm_deleted_title: 'Deleted',
  pcm_delete_success: 'Comment deleted successfully',
  pcm_delete_error: 'An error occurred while deleting the comment',
  pcm_permissions_title: 'Permissions',
  pcm_no_pin_permission: 'You do not have permission to pin comments',
  pcm_unpinned_title: 'Unpinned',
  pcm_unpinned_message: 'Comment has been unpinned',
  pcm_pinned_title: 'Pinned',
  pcm_pinned_message: 'Comment pinned successfully',
  pcm_pin_error: 'An error occurred while pinning the comment',
  pcm_no_hide_permission: 'You do not have permission to hide comments',
  pcm_hide_error: 'An error occurred while changing the comment state',
  pcm_modal_title: 'Post comments',
  pcm_pin_comment: '📌 Pin comment',
  pcm_unpin_comment: '📌 Unpin comment',
  pcm_show_comment: '👁️‍🗨️ Show comment',
  pcm_hide_comment: '👻 Hide comment',
  pcm_block_notification: 'Your comment was blocked for violating app rules',
  pcm_unblock_comment: 'Unblock comment',
  pcm_block_comment: 'Block comment',
  pcm_report_comment: 'Report comment',
  pcm_hidden_comment_title: 'This comment is hidden',
  pcm_edit_comment: 'Edit comment',
  pcm_add_comment: 'Add a comment',
  pcm_cannot_send_coins_to_self: 'You cannot send coins to your own post',
  pcm_insufficient_coins_balance: 'You do not have enough coins',
  pcm_insufficient_currency_balance: 'You do not have enough of this currency.',
  pcm_report_dialog_heading: 'Report comment',
  pcm_report_dialog_subtitle: 'Write the report details so moderators can review it better',
  pcm_report_details_label: 'Report details',
  pcm_report_details_placeholder: 'Example: this comment is offensive or contains inappropriate content...',
  pcm_send_report_btn: 'Send report',
  pcm_yes_btn: 'Yes',

  // CommentReplyModal.jsx (crm_*)
  crm_reaction_like: 'Useful',
  crm_reaction_love: 'Brilliant',
  crm_reaction_care: 'Keep going',
  crm_reaction_haha: 'Haha',
  crm_reaction_wow: 'Wow',
  crm_reaction_sad: 'Saddened me',
  crm_reaction_angry: 'Angered me',
  crm_block_police: 'Reply blocked - security violation 👮',
  crm_block_health: 'Reply blocked - health violation 🏥',
  crm_block_literature: 'Reply blocked - conduct violation 📚',
  crm_block_law: 'Reply blocked - legal violation ⚖️',
  crm_block_admin: 'Reply blocked - administrative decision 🔒',
  crm_blocked_generic: 'Reply blocked',
  crm_already_reported_title: 'Already reported',
  crm_already_reported_message: 'You have already reported this reply',
  crm_report_police_title: 'Report to Police Center',
  crm_report_police_message: 'Are you sure you want to report this reply to the Police Center?',
  crm_report_police_theft_reason: 'Police Center report for theft',
  crm_reported_title: 'Reported',
  crm_report_police_success: 'The reply has been successfully reported to the Police Center',
  crm_error_title: 'Error',
  crm_report_error: 'An error occurred while reporting',
  crm_report_health_title: 'Report to Health Center',
  crm_report_health_message: 'Are you sure you want to report this reply to the Health Center?',
  crm_report_health_depression_reason: 'Health Center report for depression',
  crm_report_health_success: 'The reply has been successfully reported to the Health Center',
  crm_report_literature_title: 'Report to Conduct Center',
  crm_report_literature_message: 'Are you sure you want to report this reply to the Conduct Center?',
  crm_report_literature_abuse_reason: 'Conduct Center report for abuse',
  crm_report_literature_success: 'The reply has been successfully reported to the Conduct Center',
  crm_report_law_title: 'Report to Law Center',
  crm_report_law_message: 'Are you sure you want to report this reply to the Law Center?',
  crm_report_law_violation_reason: 'Law Center report for legal violation',
  crm_report_law_success: 'The reply has been successfully reported to the Law Center',
  crm_login_required_for_report: 'You must be logged in to report',
  crm_report_submit_success: 'Report submitted successfully. Thank you for helping keep the community safe.',
  crm_report_submit_error: 'An error occurred while submitting the report. Please try again later.',
  crm_delete_reply_title: 'Delete reply',
  crm_delete_reply_message: 'Are you sure you want to delete this reply? This action cannot be undone.',
  crm_delete_btn: 'Delete',
  crm_cancel_btn: 'Cancel',
  crm_deleted_title: 'Deleted',
  crm_delete_success: 'Reply deleted successfully',
  crm_delete_error: 'An error occurred while deleting the reply',
  crm_surah_label: 'Surah',
  crm_banned_title: 'Banned',
  crm_banned_reply_message: 'You are banned from commenting and cannot post a reply.',
  crm_comment_deleted: 'Comment deleted',
  crm_reply_deleted: 'Reply deleted',
  crm_modal_title: 'Comment replies',
  crm_block_reason_theft: 'Stolen reply',
  crm_unblock_reply_theft: 'Unblock reply (theft)',
  crm_block_reply_theft: 'Block reply (stolen reply)',
  crm_block_reason_literature: 'Conduct-violating reply',
  crm_unblock_reply_literature: 'Unblock reply (conduct)',
  crm_block_reply_literature: 'Block reply (conduct-violating reply)',
  crm_block_reason_law: 'Illegal reply',
  crm_unblock_reply_law: 'Unblock reply (law)',
  crm_block_reply_law: 'Block reply (illegal reply)',
  crm_report_health_depression: 'Health Center report for depression',
  crm_edit_reply: 'Edit reply',
  crm_comment_label: 'Comment',
  crm_reply_on_label: 'Reply to {target}',
  crm_report_dialog_heading: 'Report reply',
  crm_report_dialog_subtitle: 'Write the report details so moderators can review it better',
  crm_report_details_label: 'Report details',
  crm_report_details_placeholder: 'Example: this reply contains abuse or a threat...',
  crm_send_report_btn: 'Send report',
  crm_yes_btn: 'Yes',

  // PostCommentsModal.jsx - extra keys (pass 2)
  pcm_coins_sent_to_post: 'Sent coins to post {name}',
  pcm_coins_sent_with_comment: 'Deduction for sending coins with a comment on a post',
  pcm_coins_received_from: 'Received coins from {name}',
  pcm_coins_received_with_comment: 'Received coins from a comment on your post',
  pcm_block_reason_fallback: 'Block/unblock comment ({blockType})',
  pcm_comments_closed_banner: '🔒 Comments are closed on this post',
  pcm_reactions_closed_banner: '💔 Reactions are closed on this post',
  pcm_no_comments_yet: 'No comments on this post yet',
  pcm_pinned_comment_badge: '📌 Pinned comment',
  pcm_edit_comment_menu: 'Edit comment',
  pcm_delete_comment_menu: 'Delete comment',
  pcm_spoiler_warning: 'This comment contains a spoiler. Click to view.',

  // CommentReplyModal.jsx - extra keys (pass 2)
  crm_block_reason_fallback: 'Block/unblock reply ({blockType})',
  crm_edit_reply_menu: 'Edit reply',
  crm_delete_reply_menu: 'Delete reply',
  crm_report_reply_menu: 'Report reply',
  crm_spoiler_warning: 'This reply contains a spoiler. Click to view.',
  crm_comments_closed_banner: 'Comments are closed on this post',

  // PostActionsComponent.jsx
  post_action_reaction_like: 'Useful',
  post_action_reaction_love: 'Brilliant',
  post_action_reaction_care: 'Keep going',
  post_action_reaction_haha: 'Haha',
  post_action_reaction_wow: 'Wow',
  post_action_reaction_sad: 'Sad',
  post_action_reaction_angry: 'Angry',
  post_action_default_post_title: 'Check out this post',
  post_action_share_text: 'Check out this post!',
  post_action_share: 'Share',
  post_action_comments: 'Comments',
  post_action_comments_closed: 'Comments Closed',
  post_action_reactions_closed: 'Reactions Closed',
  post_action_comments_closed_title: 'Comments are closed',
  post_action_comments_closed_message: 'The author has closed comments on this post.',
  post_action_ok: 'OK',
  post_action_view_comments: 'View Comments',

  // HashtagDropDown.jsx
  hashtag_dropdown_no_results_found: 'No results found',
  hashtag_dropdown_create_new: '#: Create New',

  // CommentInputBox.jsx
  comment_input_box_comment_placeholder: 'Add a comment',
  comment_input_box_invalid_image_type: 'Unsupported image format',
  comment_input_box_image_upload_failed: 'Image upload failed',
  comment_input_box_mentions_no_results_found: 'No user found with that name',
  comment_input_box_character_no_results_found: 'No characters found with that name',
  comment_input_box_character_category_prophets: 'Prophets',
  comment_input_box_character_category_companions: 'Companions',
  comment_input_box_character_category_historical: 'Historical characters',
  comment_input_box_quran_surah_no_results_found: 'No surah found with that name',
  comment_input_box_quran_surah_header: 'Quran Surahs',
  comment_input_box_quran_surah_name: 'Surah',
  comment_input_box_edit_mode_title: 'Edit comment',
  comment_input_box_comments_disabled: 'Comments are disabled',
  time_ago_just_now: 'Just now',
  time_ago_one_minute: '1 minute ago',
  time_ago_minutes: '{count} minutes ago',
  time_ago_one_hour: '1 hour ago',
  time_ago_two_hours: '2 hours ago',
  time_ago_hours: '{count} hours ago',
  time_ago_hours_alt: '{count} hours ago',
  time_ago_one_day: '1 day ago',
  time_ago_two_days: '2 days ago',
  time_ago_days: '{count} days ago',
  time_ago_days_alt: '{count} days ago',
  time_ago_one_week: '1 week ago',
  time_ago_two_weeks: '2 weeks ago',
  time_ago_weeks: '{count} weeks ago',
  time_ago_one_month: '1 month ago',
  time_ago_two_months: '2 months ago',
  time_ago_months: '{count} months ago',
  notifications_page_no_notifications: 'No notifications',
  notifications_page_title: 'Notifications',
  notifications_page_filter_all: 'All',
  notifications_page_filter_posts: 'Posts',
  notifications_page_filter_comments: 'Comments',
  notifications_page_filter_coins: 'Coins',
  notifications_page_filter_replies: 'Replies',
  notifications_page_filter_team_request: 'Team requests',
  notifications_page_filter_team_approval: 'Team approval',
  notifications_page_filter_team_promotion: 'Team promotion',
  notifications_page_filter_team_kick: 'Team kick',
  notifications_page_filter_saraha: 'Saraha',
  notifications_page_filter_coins_sent: 'Coins received',
  notifications_page_filter_blocked: 'Blocked',
  notifications_page_filter_unblocked: 'Unblocked',
  notifications_page_tab_follow: 'Follow',
  notifications_page_tab_reaction: 'Reactions',
  notifications_page_tab_messages: 'Messages',
  notifications_page_tab_general: 'General',
  notifications_page_mark_all_read: 'Mark all as read',
  notifications_page_delete_all: 'Delete all',
  notifications_page_post_blocked: 'Your post has been blocked by admin',
  notifications_page_profile_image_blocked: 'Your profile image has been blocked by admin',
  notifications_page_cover_image_blocked: 'Your cover image has been blocked by admin',
  notifications_page_reply_blocked: 'Your reply has been blocked because {reason}',
  notifications_page_comment_blocked: 'Your comment has been blocked because {reason}',
  notifications_page_reply_unblocked: 'Your reply has been unblocked',
  notifications_page_comment_unblocked: 'Your comment has been unblocked',
  notifications_page_text_chat_message: 'New message from {name}: "{snippet}"',
  notifications_page_text_follow: '{name} started following you',
  notifications_page_text_reaction_post: '{name} reacted to your post',
  notifications_page_text_reaction_comment: '{name} reacted to your comment',
  notifications_page_text_reaction_reply: '{name} reacted to your reply',
  notifications_page_text_reaction_generic: '{name} reacted to your post',
  notifications_page_text_mention: '{name} mentioned you in a post',
  notifications_page_text_comment: '{name} commented on your post',
  notifications_page_text_comment_with_message: '{name} commented on your post: "{message}"',
  notifications_page_text_comment_with_coins: '{name} sent you {coins} coins in a comment',
  notifications_page_text_coins_with_comment: '{name} sent you {coins} coins in a comment',
  notifications_page_text_reply: '{name} replied to your comment',
  notifications_page_text_reply_with_message: '{name} replied to your comment: "{message}"',
  notifications_page_text_reply_with_coins: '{name} sent you {coins} coins in a reply',
  notifications_page_text_private_message: 'Private message from {name}: "{snippet}"',
  notifications_page_text_group_message: 'Message in {group} from {name}: "{snippet}"',
  notifications_page_text_team_request: 'New request to join your team',
  notifications_page_text_team_approval: 'Your request to join {team} was approved',
  notifications_page_text_team_promotion: 'You were promoted in {team}{role}',
  notifications_page_text_team_promotion_role: ' to {role}',
  notifications_page_text_team_kick: 'You were removed from {team}',
  notifications_page_text_saraha_named: 'You received an anonymous message: "{message}"',
  notifications_page_text_saraha_from: 'You received a message from {name}: "{message}"',
  notifications_page_text_saraha_anonymous: 'You have a new anonymous message',
  notifications_page_text_saraha_generic: 'You have a new message',
  notifications_page_text_coins_sent: '{name} sent you {coins} coins',
  notifications_page_text_default: 'New notification',
  notifications_page_unknown_user: 'Someone',
  notifications_page_load_error: 'Couldn\'t load notifications. Check your connection and try again.',
  notifications_page_retry: 'Retry',
  notifications_page_delete_confirm: 'Delete this notification?',
  notifications_page_toast_from: 'From {name}',
  notifications_page_toast_new: 'New notification',
  notifications_page_toast_snooze: 'Snooze',
  notifications_page_toast_snooze_title: 'Hide for 5 minutes',
  friend_requests_title_requests: 'Friend Requests',
  friend_requests_title_contacts: 'Contacts',
  friend_requests_search_placeholder: 'Search for a contact...',
  friend_requests_no_contacts: 'You haven\'t added any contacts yet.',
  friend_requests_no_results: 'No matching results.',
  friend_requests_sent_you_request: 'Sent you a friend request',
  friend_requests_accept_btn: 'Accept',
  friend_requests_reject_btn: 'Reject',
  friend_requests_no_new_requests: 'No new friend requests',
  friend_requests_edit_name_dialog: 'Edit Name',
  friend_requests_update_btn: 'Update',
  friend_requests_cancel_btn: 'Cancel',
  friend_requests_profile_image_alt: 'Profile image',
  friend_requests_more_options_label: 'More options',
  friend_requests_contacts_count_label: 'contacts',
  friend_requests_favorites_section: 'Favorites',
  friend_requests_remove_favorite: 'Remove favorite',
  friend_requests_add_favorite: 'Add to favorites',
  friend_requests_remove_contact: 'Remove contact',
  friend_requests_incoming_tab: 'Incoming',
  friend_requests_add_person_tab: 'Add person',
  friend_requests_add_person_search_placeholder: 'Search by UID or handle',
  friend_requests_add_person_hint: 'Search by UID or username to add someone',
  friend_requests_add_person_searching: 'Searching...',
  friend_requests_add_person_no_results: 'No users found',
  friend_requests_already_related_label: 'Already related',
  friend_requests_request_sent_label: 'Request sent',
  friend_requests_send_request_btn: 'Send request',
  friend_requests_send_request_error: 'Failed to send friend request',
  messages_title: 'Messages',
  messages_group_fallback: 'Group',
  messages_search_chats_placeholder: 'Search conversations...',
  messages_search_groups_placeholder: 'Search groups...',
  messages_search_aria: 'Search',
  messages_new_group_aria: 'New group',
  messages_tab_friends: 'Contacts',
  messages_tab_groups: 'Groups',
  messages_start_chat_now: 'Start the conversation now...',
  messages_no_previous_chats: 'You do not have previous messages. Tap the button below to start a conversation.',
  messages_no_results: 'No matching results.',
  messages_public_groups: 'Public groups',
  messages_public_groups_subtitle: 'Discover and explore communities',
  messages_no_messages: 'No messages...',
  messages_no_groups: 'You do not have any groups right now. You can create a group or join groups from discover.',
  messages_new_message: 'New message',
  messages_create_group: 'Create group',
  messages_unmute_notifications: 'Unmute notifications',
  messages_mute_notifications: 'Mute notifications',
  messages_rename: 'Rename',
  messages_cancel_report: 'Cancel report',
  messages_report: 'Report',
  messages_leave_group: 'Leave group',
  messages_new_chat_search_placeholder: 'Search for a person...',
  messages_start_new_chat: 'Start a new conversation',
  messages_no_available_people: 'No people are available to start a new conversation.',
  messages_no_results_short: 'No results.',
  messages_rename_contact_title: 'Rename contact',
  messages_rename_contact_subtitle: 'This name will only appear to you',
  messages_rename_placeholder: 'Type the new name...',
  messages_cancel: 'Cancel',
  messages_save: 'Save',
  messages_loading: 'Loading...',
  messages_load_more: 'Load more',
  messages_deleted_message: 'This message was deleted',
  quran_title: 'Quran',
  quran_my_list: 'My list',
  quran_loading: 'Loading...',
  quran_search_placeholder: 'Search for a surah...',
  quran_sync_success_title: 'Synced',
  quran_sync_success_message: '{count} changes were synced with the server successfully',
  quran_offline_title: 'No connection',
  quran_offline_message: 'You do not have internet right now. Data will be saved locally and synced with the server the next time you connect.',
  quran_unavailable_offline_title: 'Unavailable offline',
  quran_unavailable_offline_message: 'This surah has not been opened before and has no saved copy. Please connect to the internet to open it for the first time.',
  quran_tab_reading: 'Reading',
  quran_tab_details: 'Details',
  quran_no_cached_surah: 'There is no internet connection and no saved copy for this surah.',
  quran_open_once_hint: 'Open it once while connected so it can be saved for offline use.',
  quran_reset_progress_title: 'Reset progress',
  quran_skip_ayahs_title: 'Skip verses',
  quran_skip_ayahs_message: 'Are you sure you have read up to verse {target}? Your last read verse was {last}.',
  quran_reset_progress_message: 'Are you sure you want to reset your reading progress for {surah}? All progress will be deleted.',
  quran_info_type: 'Type',
  quran_info_ayahs: 'Verses',
  quran_info_surah_number: 'Surah number',
  quran_memorization_status: 'Memorization status',
  quran_status_none: '-- None --',
  quran_status_want_to_memorize: 'I want to memorize it',
  quran_status_memorizing: 'Currently memorizing',
  quran_status_memorized: 'Memorized',
  quran_status_later: 'Memorize later',
  quran_status_difficult: 'Difficult to memorize',
  quran_revelation_meccan: 'Meccan',
  quran_revelation_medinan: 'Medinan',
  quran_ayah_count: '{count} verses',
  my_quran_list_empty_status: 'No surahs in this status',
  deleted_posts_title: 'Deleted posts',
  deleted_posts_checking_permissions: 'Checking permissions...',
  deleted_posts_no_permission: 'You do not have permission to access this page',
  deleted_posts_search_placeholder: 'Search by Post ID, User ID, or name...',
  deleted_posts_search_prompt: 'Search to show deleted posts. Results load only after searching to reduce usage.',
  deleted_posts_loading: 'Loading deleted posts...',
  deleted_posts_empty: 'No deleted posts',
  deleted_posts_no_results: 'No search results found',
  deleted_posts_deleted_at: 'Deleted',
  deleted_posts_recover_title: 'Recover post',
  deleted_posts_recover_message: 'Do you want to recover this post?',
  deleted_posts_recover_confirm: 'Recover',
  deleted_posts_permanent_delete_title: 'Permanent delete',
  deleted_posts_permanent_delete_message: 'Do you want to permanently delete this post? This action cannot be undone.',
  deleted_posts_permanent_delete_confirm: 'Delete permanently',
  deleted_posts_yes: 'Yes',
  deleted_posts_cancel: 'Cancel',
  create_post_list_title: 'Create new list',
  create_post_list_image_label: 'List image',
  create_post_list_uploading: 'Uploading...',
  create_post_list_image_hint: 'Tap to choose the cover image for the list',
  create_post_list_name_label: 'List name',
  create_post_list_name_placeholder: 'Enter the list name here...',
  create_post_list_create_button: 'Create list',
  create_post_list_creating: 'Creating...',
  create_post_list_valid_image_required: 'Please choose a valid image',
  create_post_list_upload_error: 'An error occurred while uploading the image',
  create_post_list_name_and_image_required: 'Please enter a list name and choose an image',
  create_post_list_success: 'List created successfully!',
  create_post_list_create_error: 'An error occurred while creating the list',
  saved_posts_title: 'Saved posts',
  saved_posts_loading: 'Loading...',
  saved_posts_empty: 'No saved posts',
  team_posts_loading: 'Loading...',
  team_posts_team_fallback: 'Team',
  team_posts_empty: 'No posts for this team',
  team_posts_load_error: 'An error occurred while loading posts',
  team_posts_retry: 'Retry',
  team_posts_load_more: 'Load more',
  team_posts_try_another: 'Try searching for another team',
  team_posts_back_home: 'Back to home',
  team_posts_count: '{count} posts',
  team_posts_level: 'Level: {level}',
  hashtag_posts_loading: 'Loading posts...',
  hashtag_posts_empty: 'No posts with this hashtag yet',
  hashtag_posts_load_error: 'Could not load hashtag posts',
  profile_menu_no_daily_quiz_today: 'No question is available for today',
  profile_menu_frame_alt: 'Profile frame',
  profile_menu_verified_alt: 'Verified',
  profile_menu_coin_alt: 'Coin',
  profile_menu_point_alt: 'Point',
  profile_menu_ok: 'OK',
  manage_hashtags_title: 'Manage hashtags',
  manage_hashtags_loading: 'Loading...',
  manage_hashtags_empty: 'You have not created any hashtags yet',
  manage_hashtags_usage_count: 'Used {count} times',
  manage_hashtags_private: 'Private',
  manage_hashtags_delete_title: 'Delete hashtag',
  manage_hashtags_delete_message: 'Are you sure you want to delete #{hashtag}?',
  staff_loading: 'Loading...',
  staff_title: 'Staff',
  staff_empty: 'No data available',
  staff_group_1: 'Senior administration',
  staff_group_technical_content: 'Content technical department',
  staff_group_2: 'Content department',
  staff_group_3: 'Events department',
  staff_group_4: 'Data department',
  staff_group_5: 'Other',
  staff_role_1: 'Super admin',
  staff_role_1_5: 'Deputy super admin',
  staff_role_1_6: 'Content technical department manager',
  staff_role_1_7: 'Content technician',
  staff_role_2: 'Content department manager',
  staff_role_3: 'Content moderator',
  staff_role_4: 'Events department manager',
  staff_role_5: 'Events moderator',
  staff_role_6: 'Data department manager',
  staff_role_7: 'Data moderator',
  staff_role_10: 'Unassigned',
  staff_role_user: 'User',
  staff_role_unassigned: 'Unassigned',
  staff_change_role_title: 'Change {name} role',
  staff_save: 'Save',
  staff_cancel: 'Cancel',
  tasbeeh_title: 'Adhkar challenge',
  tasbeeh_tab_recent: 'Recent',
  tasbeeh_tab_favorites: 'Favorites',
  tasbeeh_tab_main: 'Main',
  tasbeeh_empty_favorites: 'You have not added anything to favorites yet',
  tasbeeh_empty_recent: 'You have not used any adhkar recently',
  tasbeeh_show_adhkar: 'Show adhkar',
  tasbeeh_counter_sync_title: 'Synced',
  tasbeeh_counter_sync_message: 'Your progress was synced with the server successfully',
  tasbeeh_counter_offline_title: 'No connection',
  tasbeeh_counter_offline_message: 'You are offline right now. Data will be saved locally and synced with the server the next time you open the page.',
  tasbeeh_counter_purple_potion_title: 'Purple Potion used',
  tasbeeh_counter_purple_potion_message: 'Purple Lazy Potion was used. Your tasbeeh and adhkar progress were both protected.',
  tasbeeh_counter_streak_broken_title: 'Progress streak broke',
  tasbeeh_counter_streak_broken_message: 'Your streak was {count} days and has now reset. Start again.',
  tasbeeh_counter_blue_potion_title: 'Blue Potion used',
  tasbeeh_counter_blue_potion_message: 'Blue Lazy Potion was used to protect your tasbeeh progress.',
  tasbeeh_counter_badge_name: 'Shield level {level}',
  tasbeeh_counter_badge_updated_title: 'Badge updated',
  tasbeeh_counter_badge_updated_message: 'Congratulations! Your badge was upgraded to shield level {level} after {count} consecutive days.',
  tasbeeh_counter_badge_new_title: 'New badge',
  tasbeeh_counter_badge_new_message: 'Congratulations! You earned shield level {level} after {count} consecutive days.',
  tasbeeh_counter_temp_block_title: 'Temporarily blocked',
  tasbeeh_counter_temp_block_message: 'A temporary block was activated for {count} minutes because of cheating attempts. Try again later.',
  tasbeeh_counter_no_cheating_title: 'Cheating is not allowed',
  tasbeeh_counter_no_cheating_message: 'Cheating is not allowed. A temporary block was activated for {count} minutes.',
  tasbeeh_counter_next_level: 'Next level',
  tasbeeh_counter_streak_days: '{count} consecutive days',
  tasbeeh_counter_tap_anywhere: 'Tap anywhere to count',
  tasbeeh_counter_achievement_title: '🎖️ New achievement point!',
  tasbeeh_counter_achievement_message: 'You reached {count} dhikr! You earned a "Dhakir" achievement point 📿',
  tasbeeh_counter_goal_modal_title: 'Daily goal',
  tasbeeh_counter_goal_modal_description: 'Choose how many dhikr you need to reach in order to earn one achievement point.',
  tasbeeh_counter_goal_modal_label: 'Goal',
  tasbeeh_counter_goal_modal_save: 'Save',
  tasbeeh_counter_goal_modal_cancel: 'Cancel',
  tasbeeh_counter_goal_modal_invalid: 'Please enter a number between {min} and {max}',
  tasbeeh_sequence_mode: 'Sequence mode',
  tasbeeh_sequence_hint: 'Select the adhkar in the order you want to recite them',
  tasbeeh_sequence_start: 'Start sequence ({count})',
  tasbeeh_sequence_cancel: 'Cancel',
  tasbeeh_sequence_min_error: 'Select at least two adhkar to start a sequence',
  tasbeeh_sequence_progress: 'Dhikr {current} of {total}',
  tasbeeh_sequence_mix_total: 'Mix total: {count}',
  tasbeeh_sequence_next_label: 'Next dhikr',
  tasbeeh_sequence_complete_title: 'Sequence complete! 🎉',
  tasbeeh_sequence_complete_message: 'Well done! You completed all the adhkar in your sequence.',
  store_title: 'Amposter Store',
  store_subtitle: 'Discover useful items and add-ons',
  store_points_unit: 'points',
  store_coins_unit: 'coins',
  store_current_pack: 'Current pack',
  store_active_pack: 'Active pack',
  store_remaining_days: '{count} days left',
  store_expired: 'Expired',
  store_coming_soon: 'Coming soon',
  store_category_conversion: 'Coins and points exchange',
  store_category_potions: 'Tools store',
  store_category_reactions: 'Reaction icons',
  store_category_stickers: 'Stickers store',
  store_category_bubbles: 'Bubbles store',
  store_category_frames: 'Profile frames',
  store_category_themes: 'Coming soon',
  store_category_special: 'Special offers',
  store_convert_coins_to_points: 'Convert coins to points',
  store_convert_points_to_coins: 'Convert points to coins',
  store_convert_coins_subtitle: 'Convert your coins into points to buy items',
  store_convert_points_subtitle: 'Convert your points into coins',
  store_current_tax: 'Current tax',
  store_example: 'Example',
  store_conversion_amount_label: 'Amount to convert ({unit})',
  store_enter_amount: 'Enter amount',
  store_coins_to_convert: 'Coins to convert',
  store_points_to_convert: 'Points to convert',
  store_tax: 'Tax',
  store_points_received: 'Points received',
  store_coins_received: 'Coins received',
  store_not_enough_points: 'Sorry, you do not have enough points',
  store_not_enough_points_purchase: 'You do not have enough points to complete the purchase',
  store_purchase_success_named: '{name} purchased successfully!',
  store_purchase_error: 'An error occurred during purchase',
  store_blue_potion_name: 'Blue Lazy Potion',
  store_blue_potion_desc: 'Protects your tasbeeh streak from breaking',
  store_orange_potion_name: 'Orange Lazy Potion',
  store_orange_potion_desc: 'Protects your adhkar streak from breaking',
  store_purple_potion_name: 'Rare Lazy Potion',
  store_purple_potion_desc: 'Protects both your tasbeeh and adhkar streaks',
  store_potions_title: 'Tools store',
  store_potions_subtitle: 'Protect your progress with Lazy Potions',
  store_owned_count: 'Owned: {count}',
  store_buying: 'Buying...',
  store_buy: 'Buy',
  store_confirm_purchase_title: 'Confirm purchase',
  store_confirm_purchase_message: 'Do you want to buy {name}?',
  store_yes: 'Yes',
  store_no: 'No',
  store_stickers_title: 'Stickers store',
  store_stickers_subtitle: 'Buy sticker packs to make your chats stand out',
  store_sticker: 'Sticker',
  store_stickers_preview: 'Stickers preview',
  store_sticker_purchase_success: 'Sticker pack purchased successfully!',
  store_owned: 'Owned',
  store_already_owned: 'Already owned',
  store_no_stickers: 'No stickers are available for purchase right now.',
  store_preview: 'Preview',
  store_reactions_title: 'Reaction icons store',
  store_reactions_subtitle: 'Choose your favorite icon pack',
  store_reaction_pack_name: 'Icon pack {number}',
  store_reaction_pack_default_desc: 'Default pack - free',
  store_reaction_pack_desc: 'A set of 7 unique reaction icons - valid for 30 days',
  store_reactions_preview: 'Icons preview',
  store_active: 'Active',
  store_free: 'Free',
  store_active_now: 'Active now',
  store_activate: 'Activate',
  store_activate_free: 'Activate for free',
  store_loading: 'Loading...',
  store_login_required: 'You must log in to access the store',
  moderation_logs_title: 'Moderator action logs',
  moderation_logs_loading: 'Loading...',
  moderation_logs_tab_logs: 'Logs',
  moderation_logs_tab_stats: 'Statistics',
  moderation_logs_total_actions: 'Total actions',
  moderation_logs_need_verification: 'Actions needing verification',
  moderation_logs_verified_actions: 'Verified actions',
  moderation_logs_by_action_type: 'By action type',
  moderation_logs_by_content_type: 'By content type',
  moderation_logs_by_block_type: 'By block type',
  moderation_logs_action_block: 'Block',
  moderation_logs_action_block_theft: 'Content theft block',
  moderation_logs_action_block_abuse: 'Abuse block',
  moderation_logs_action_block_legal: 'Legal violation block',
  moderation_logs_action_unblock: 'Unblock',
  moderation_logs_action_unblock_theft: 'Unblock content theft',
  moderation_logs_action_unblock_abuse: 'Unblock abuse',
  moderation_logs_action_unblock_legal: 'Unblock legal violation',
  moderation_logs_action_delete: 'Delete post',
  moderation_logs_action_delete_short: 'Delete',
  moderation_logs_action_report: 'Report',
  moderation_logs_content_post: 'Post',
  moderation_logs_content_comment: 'Comment',
  moderation_logs_content_reply: 'Reply',
  moderation_logs_content_profile_image: 'Profile image',
  moderation_logs_content_cover_image: 'Cover image',
  moderation_logs_block_theft: 'Content theft',
  moderation_logs_block_abuse: 'Abuse',
  moderation_logs_block_legal: 'Legal violation',
  moderation_logs_search_placeholder: 'Search moderator, user, or ID...',
  moderation_logs_filter: 'Filter',
  moderation_logs_verification_status: 'Verification status',
  moderation_logs_unverified: 'Unverified',
  moderation_logs_verified: 'Verified',
  moderation_logs_all: 'All',
  moderation_logs_action_type: 'Action type',
  moderation_logs_moderator: 'Moderator',
  moderation_logs_empty: 'No logs',
  moderation_logs_on: 'On',
  moderation_logs_reason: 'Reason',
  moderation_logs_type: 'Type',
  moderation_logs_review_content: 'Review content',
  moderation_logs_review: 'Review',
  moderation_logs_mark_verified: 'Mark verified',
  moderation_logs_confirm_title: 'Confirm verification',
  moderation_logs_confirm_message: 'Are you sure this log has been reviewed and verified?',
  moderation_logs_confirm_yes: 'Yes, verified',
  moderation_logs_cancel: 'Cancel',
  adhkar_benefit_title: 'Benefit',
  adhkar_benefit_aria: 'Show benefit',
  adhkar_once: 'time',
  adhkar_times: 'times',
  adhkar_tap_hint: 'Tap to count',
  adhkar_completed_items: 'Completed adhkar ({count})',
  adhkar_loading: 'Loading adhkar...',
  adhkar_back: 'Back',
  adhkar_title: 'Morning and Evening Adhkar',
  adhkar_subtitle: 'Tap each dhikr to count it. Tap ? to see the benefit.',
  adhkar_morning_tab: 'Morning adhkar',
  adhkar_evening_tab: 'Evening adhkar',
  adhkar_progress: 'Progress',
  adhkar_streak_days: '{count} days',
  adhkar_done_title: 'Well done! You completed all adhkar',
  adhkar_done_subtitle: 'May Allah accept it from you and bless your day',
  adhkar_done_badge_subtitle: 'Congratulations, you earned a badge for finishing today',
  adhkar_benefit_dialog_title: 'Dhikr benefit',
  adhkar_reorder_btn: 'Reorder adhkar',
  adhkar_reorder_done_btn: 'Done',
  adhkar_reorder_hint: 'Drag ☰ to reorder, or use the arrows',
  adhkar_reset_order_btn: 'Reset to default order',
  adhkar_reset_order_confirm_title: 'Reset to default order?',
  adhkar_reset_order_confirm_message: 'The adhkar order will go back to its original state. Your custom and hidden adhkar are not affected.',
  adhkar_drag_handle: 'Drag to reorder',
  adhkar_move_up: 'Move up',
  adhkar_move_down: 'Move down',
  adhkar_custom_badge: 'Private',
  adhkar_delete_custom: 'Delete this custom dhikr',
  adhkar_add_custom_btn: 'Add custom dhikr',
  adhkar_add_custom_title: 'Add your own dhikr',
  adhkar_add_custom_name_label: 'Dhikr name',
  adhkar_add_custom_text_label: 'Dhikr text',
  adhkar_add_custom_repeat_label: 'Repeat count',
  adhkar_add_custom_benefit_label: 'Benefit (optional)',
  adhkar_add_custom_cancel: 'Cancel',
  adhkar_add_custom_save: 'Save',
  adhkar_add_custom_saving: 'Saving...',
  adhkar_add_custom_error: 'Please enter the dhikr text first',
  adhkar_hide_base: 'Hide this dhikr',
  adhkar_restore_base: 'Restore',
  adhkar_hidden_items: 'Hidden adhkar ({count})',
  adhkar_min_count_title: 'Minimum adhkar required',
  adhkar_min_count_message: 'At least {count} adhkar must remain in this section. Add another dhikr first if you want to remove or hide more.',
  suggestions_box_status_all: 'All',
  suggestions_box_status_pending: 'Pending review',
  suggestions_box_status_in_development: 'In development',
  suggestions_box_status_completed: 'Completed',
  suggestions_box_status_rejected: 'Rejected',
  suggestions_box_moderator: 'Moderator',
  suggestions_box_user: 'User',
  suggestions_box_reply_placeholder: 'Write your reply to this request...',
  suggestions_box_sending: 'Sending',
  suggestions_box_send_reply: 'Send reply',
  suggestions_box_type_suggestion: 'Suggestion',
  suggestions_box_type_problem: 'Problem',
  suggestions_box_request_content: 'Request content',
  suggestions_box_change_status: 'Change status',
  suggestions_box_delete_request: 'Delete request',
  suggestions_box_moderator_replies: 'Moderator replies ({count})',
  suggestions_box_recently: 'Just now',
  suggestions_box_confirm: 'Confirm',
  suggestions_box_cancel: 'Cancel',
  suggestions_box_confirm_status_title: 'Confirm status change',
  suggestions_box_confirm_status_message: 'Change request status to "{status}"?',
  suggestions_box_done: 'Done',
  suggestions_box_error: 'Error',
  suggestions_box_status_success: 'Status updated successfully',
  suggestions_box_status_error: 'Could not update status',
  suggestions_box_delete_title: 'Delete request',
  suggestions_box_delete_message: 'Do you want to permanently delete this {type}? Related replies will also be deleted.',
  suggestions_box_delete: 'Delete',
  suggestions_box_deleted: 'Deleted',
  suggestions_box_delete_success: 'Request deleted successfully',
  suggestions_box_delete_error: 'Could not delete request',
  suggestions_box_title: 'Suggestions and Problems Box',
  suggestions_box_loading: 'Loading...',
  suggestions_box_total: 'Total',
  suggestions_box_waiting_review: 'Awaiting review',
  suggestions_box_empty_title: 'No requests',
  suggestions_box_empty_message: 'No requests match the selected filter.',
  create_plan_plan_title: 'Today\'s Plan',
  create_plan_title: 'Create Today\'s Plan',
  create_plan_remaining_questions: '{count} questions remaining',
  create_plan_fetching_prayer_times: 'Fetching prayer times...',
  create_plan_loading_settings: 'Loading your settings...',
  create_plan_ready_title: 'Ready to build the plan!',
  create_plan_ready_subtitle: 'All questions have been answered',
  create_plan_create_daily_plan: 'Create daily plan',
  create_plan_back: 'Back',
  create_plan_reset_all: 'Start over',
  create_plan_question_hasWork: 'Do you have work today?',
  create_plan_option_hasWork_yes_today: 'Yes, today',
  create_plan_option_hasWork_no_today: 'No, not today',
  create_plan_option_hasWork_yes_always: 'I always have work',
  create_plan_option_hasWork_no_always: 'I never have work',
  create_plan_question_workStartTime: 'When does your shift start?',
  create_plan_question_workEndTime: 'When does your shift end?',
  create_plan_question_hasSchool: 'Do you have school or university today?',
  create_plan_yes_hasSchool: 'Yes, today',
  create_plan_no_hasSchool: 'No, I do not',
  create_plan_question_schoolStartTime: 'When does school or university start?',
  create_plan_question_schoolEndTime: 'When does school or university end?',
  create_plan_question_mealsPerDay: 'How many times do you eat per day?',
  create_plan_option_mealsPerDay_1: 'Once',
  create_plan_option_mealsPerDay_2: 'Twice',
  create_plan_option_mealsPerDay_3: 'Three times',
  create_plan_question_breakfastTime: 'When is breakfast?',
  create_plan_question_lunchTime: 'When is lunch?',
  create_plan_question_dinnerTime: 'When is dinner?',
  create_plan_question_cookOwnMeals: 'Do you usually cook your own meals?',
  create_plan_yes_cookOwnMeals: 'Yes, I cook myself',
  create_plan_no_cookOwnMeals: 'No, they are prepared for me',
  create_plan_question_addPrayers: 'Add the obligatory prayers to the plan?',
  create_plan_yes_addPrayers: 'Yes, add them',
  create_plan_no_addPrayers: 'No thanks',
  create_plan_question_country: 'What is your country?',
  create_plan_subtitle_country: 'Used to calculate prayer times accurately',
  create_plan_question_addSunnah: 'Add sunnah prayers too?',
  create_plan_yes_addSunnah: 'Yes, add them',
  create_plan_no_addSunnah: 'No, obligatory prayers only',
  create_plan_question_isWudu: 'Do you have wudu now?',
  create_plan_yes_isWudu: 'Yes, I have wudu',
  create_plan_no_isWudu: 'No, I do not',
  create_plan_question_addAdhkar: 'Add morning and evening adhkar?',
  create_plan_yes_addAdhkar: 'Yes, add them',
  create_plan_no_addAdhkar: 'No thanks',
  create_plan_question_wantStudyToday: 'Do you want to study today?',
  create_plan_yes_wantStudyToday: 'Yes',
  create_plan_no_wantStudyToday: 'Not today',
  create_plan_question_studyHours: 'How many hours would you like to study?',
  create_plan_option_studyHours_1: 'One hour',
  create_plan_option_studyHours_2: 'Two hours',
  create_plan_option_studyHours_3: '3 hours',
  create_plan_option_studyHours_4: '4 hours',
  create_plan_option_studyHours_5: '5 hours',
  create_plan_option_studyHours_6: '6 hours',
  create_plan_question_studySessionDuration: 'How long should each study session be?',
  create_plan_question_doesHousework: 'Are you responsible for housework?',
  create_plan_yes_doesHousework: 'Yes, I am responsible',
  create_plan_no_doesHousework: 'No, someone else does it',
  create_plan_question_needLaundry: 'Do you need to do laundry today?',
  create_plan_question_laundryDuration: 'How long will laundry take?',
  create_plan_question_needSweep: 'Do you need to sweep the house today?',
  create_plan_question_sweepDuration: 'How much time do you need for sweeping?',
  create_plan_question_needOrganizeHome: 'Do you need to organize the house today?',
  create_plan_question_organizeDuration: 'How much time do you need to organize the house?',
  create_plan_question_wantsHygiene: 'Do you need to do personal care tasks today?',
  create_plan_yes_wantsHygiene: 'Yes, today',
  create_plan_no_wantsHygiene: 'No, not today',
  create_plan_question_hygieneTypes: 'What do you want to do today?',
  create_plan_question_barberDistance: 'How far is the barber?',
  create_plan_question_barberWait: 'How long do you usually wait at the barber?',
  create_plan_question_wantsVisit: 'Would you like to visit a friend or relative today?',
  create_plan_yes_wantsVisit: 'Yes, I have a visit',
  create_plan_no_wantsVisit: 'No, not today',
  create_plan_question_visitTime: 'When is the visit?',
  create_plan_question_visitDuration: 'How long is the expected visit?',
  create_plan_question_wantsExercise: 'Do you have exercise today?',
  create_plan_yes_wantsExercise: 'Yes, I have exercise',
  create_plan_no_wantsExercise: 'No, not today',
  create_plan_question_exerciseDuration: 'How long is the exercise?',
  create_plan_question_wantsHobby: 'Do you want to reserve time for a hobby today?',
  create_plan_yes_wantsHobby: 'Yes, I want that',
  create_plan_no_wantsHobby: 'Not today',
  create_plan_question_hobbyName: 'What is your hobby?',
  create_plan_question_hobbyDuration: 'How much time do you want to reserve for the hobby?',
  create_plan_question_hasAppointments: 'Do you have an appointment with someone today?',
  create_plan_yes_hasAppointments: 'Yes, I have an appointment',
  create_plan_no_hasAppointments: 'No, I do not',
  create_plan_question_appointment1Time: 'When is your first appointment?',
  create_plan_question_hasAppointment2: 'Do you have another appointment?',
  create_plan_yes_hasAppointment2: 'Yes, another appointment',
  create_plan_no_hasAppointment2: 'No, that is all',
  create_plan_question_appointment2Time: 'When is your second appointment?',
  prayer_tracker_title: 'Prayer Tracker',
  prayer_tracker_tab_prayers: 'Prayers',
  prayer_tracker_tab_missed: 'Missed',
  prayer_tracker_tab_adhkar: 'Adhkar',
  prayer_tracker_sunnah_streak: 'Sunnah streak',
  prayer_tracker_fard_progress: 'Obligatory {done}/{total}',
  prayer_tracker_sunnah_progress: 'Sunnah {done}/{total}',
  characters_title: 'Islamic Characters',
  characters_add_character: 'Add character',
  characters_send_contribution: 'Send contribution',
  characters_search_placeholder: 'Search for a character...',
  characters_tab_prophets: 'Prophets',
  characters_tab_companions: 'Companions',
  characters_tab_historical: 'Historical characters',
  characters_top_contributors: 'Top contributors',
  characters_contributions_count: 'Contributions ({count})',
  characters_no_results: 'No results',
  my_reports_title: 'My Reports',
  my_reports_loading: 'Loading your reports...',
  my_reports_refresh: 'Refresh',
  my_reports_refreshing: 'Refreshing',
  my_reports_create: 'Create',
  my_reports_create_subtitle: 'New suggestion or problem',
  my_reports_total: 'Total',
  my_reports_active: 'Under review',
  my_reports_replied: 'Replied',
  my_reports_done: 'Completed',
  my_reports_reports_tab: 'Reports',
  my_reports_suggestions_tab: 'Problems / Suggestions',
  my_reports_search_placeholder: 'Search...',
  my_reports_show_filters: 'Show filters',
  my_reports_no_reports: 'No reports',
  my_reports_no_suggestions: 'No problems / suggestions',
  my_reports_no_reports_message: 'Reports you send from any section will appear here with their status and messages.',
  my_reports_no_suggestions_message: 'Suggestions or problems you send will appear here with their status and reply.',
  my_reports_submit_success: 'Request sent successfully',
  my_reports_submit_error: 'Could not send request',
  my_reports_edit_request: 'Edit request',
  my_reports_new_request: 'New request',
  my_reports_edit_suggestion_problem: 'Edit suggestion or problem',
  my_reports_suggestion_problem: 'Suggestion or problem',
  my_reports_close: 'Close',
  my_reports_cancel_edit: 'Cancel edit',
  my_reports_suggestion: 'Suggestion',
  my_reports_problem: 'Problem',
  my_reports_suggestion_placeholder: 'Write your suggestion here...',
  my_reports_problem_placeholder: 'Write the problem details here...',
  my_reports_sending: 'Sending',
  my_reports_send: 'Send',
  my_reports_active_limit: 'You have {activeCount} active requests. You can send up to {max} requests before they are approved or completed.',
  reports_title: 'Moderation Center',
  reports_search_placeholder: 'Search...',
  reports_show_filters: 'Show filters',
  reports_loading: 'Loading data...',
  reports_stat_pending: 'Pending',
  reports_stat_investigating: 'Investigating',
  reports_stat_escalated: 'Escalated',
  reports_stat_high_risk: 'High risk',
  reports_stat_action_taken: 'Action taken',
  reports_stat_rejected: 'Rejected',
  reports_filter_active: 'Active requests',
  reports_filter_all_statuses: 'All statuses',
  reports_filter_all_types: 'All types',
  reports_filter_all_priorities: 'All priorities',
  reports_filter_high_risk: 'High risk (70%+)',
  reports_sort_newest: 'Newest',
  reports_sort_severity: 'Highest severity',
  reports_sort_escalated: 'Escalated first',
  reports_filter_count: '{count} reports',
  reports_empty: 'No reports match the filters',
  daily_missions_loading_title: 'Today\'s Missions',
  daily_missions_loading: 'Loading missions...',
  daily_missions_title: 'App missions',
  daily_missions_rank: 'RANK',
  daily_missions_rank_info: 'Rank information',
  daily_missions_mana_info: 'Mana information',
  daily_missions_bonus_info: 'Team bonus information',
  daily_missions_empty_mana: 'Empty energy!',
  daily_missions_adventurer: 'Adventurer',
  daily_missions_coins: 'Coins',
  daily_missions_today_missions: 'Today\'s missions',
  daily_missions_total_completed: 'Total completed',
  daily_missions_team_level: 'Level {level}',
  daily_missions_team_bonus_coins: '+{count} coins',
  daily_missions_mana_depleted_banner: '⚠️ Your daily energy is depleted! You accepted {accepted}/{limit} missions today. Raise your rank to increase your daily limit.',
  daily_missions_all_categories: '🗡️ All',
  daily_missions_category_engagement: 'Engagement',
  daily_missions_category_creation: 'Creation',
  daily_missions_category_social: 'Social',
  daily_missions_category_dhikr: 'Dhikr',
  daily_missions_show_locked: 'Show locked',
  daily_missions_hide_locked: 'Hide locked',
  daily_missions_mana_depleted_title: 'Your daily energy is depleted',
  daily_missions_mana_depleted_dialog_title: '⚡ Energy depleted',
  daily_missions_mana_depleted_dialog_message: 'You reached your daily limit ({limit} missions). Raise your rank to increase your energy!',
  daily_missions_daily_mana_limit_title: '⚡ Daily energy depleted',
  daily_missions_daily_mana_limit_message: 'You reached your daily limit ({limit} missions). Raise your rank to increase your daily energy!',
  daily_missions_no_mana_title: '⚡ No energy',
  daily_missions_no_mana_message: 'You cannot accept a new mission because your energy is empty.',
  daily_missions_failure_title: '⚡ Failed',
  daily_missions_mana_deduct_error: 'Could not deduct energy. Please try again later.',
  daily_missions_error_title: 'Error',
  daily_missions_accept_error: 'Could not accept the mission. Please try again.',
  daily_missions_must_accept_title: 'Accept the mission first',
  daily_missions_must_accept_message: 'You must accept the mission before you can claim its reward.',
  daily_missions_incomplete_title: 'Incomplete',
  daily_missions_incomplete_message: 'You have not completed this mission yet.',
  daily_missions_claim_success_title: '🎉 Reward claimed!',
  daily_missions_claim_success_message: 'You received {coins} coins and {xp} XP{team}',
  daily_missions_claim_success_team_points: ' + {points} team points',
  daily_missions_claim_error: 'Could not claim the reward. Please try again.',
  daily_missions_accept: 'Accept',
  daily_missions_claim: 'Claim',
  daily_missions_empty: 'No missions are available in this category right now',
  daily_missions_empty_subtitle: 'Raise your rank to unlock new missions',
  daily_missions_footer_reset: 'Daily missions reset every day · {date}',
  daily_missions_info_mana_title: '⚡ Mana System',
  daily_missions_info_mana_line_0: 'Energy represents how many daily missions you can accept.',
  daily_missions_info_mana_line_1: 'Each user has a daily limit based on rank:',
  daily_missions_info_mana_line_2: '• Rank F → 4 missions/day',
  daily_missions_info_mana_line_3: '• Rank E → 5 missions/day',
  daily_missions_info_mana_line_4: '• Rank D → 6 missions/day',
  daily_missions_info_mana_line_5: '• Rank C → 7 missions/day',
  daily_missions_info_mana_line_6: '• Rank B → 8 missions/day',
  daily_missions_info_mana_line_7: '• Rank A → 9 missions/day',
  daily_missions_info_mana_line_8: '• Rank S → 10 missions/day',
  daily_missions_info_mana_line_9: 'Every accepted mission lowers the energy bottle. Raise your rank to increase daily energy!',
  daily_missions_info_bonus_title: '🪙 Team Bonus System',
  daily_missions_info_bonus_line_0: 'If you are in a team, you receive extra coins when claiming any mission reward.',
  daily_missions_info_bonus_line_1: 'The bonus depends on your team level:',
  daily_missions_info_bonus_line_2: '• Level 1 → +2 coins',
  daily_missions_info_bonus_line_3: '• Level 2 → +5 coins',
  daily_missions_info_bonus_line_4: '• Level 3 → +8 coins',
  daily_missions_info_bonus_line_5: '• Level 4 → +12 coins',
  daily_missions_info_bonus_line_6: '• Level 5 → +15 coins',
  daily_missions_info_bonus_line_7: '• Level 6 → +20 coins',
  daily_missions_info_bonus_line_8: '• Level 7 → +24 coins',
  daily_missions_info_bonus_line_9: '• Level 8 → +30 coins',
  daily_missions_info_bonus_line_10: '• Level 9 → +35 coins',
  daily_missions_info_bonus_line_11: '• Level 10+ → +40 coins',
  daily_missions_info_bonus_line_12: 'Level up your team together to earn bigger rewards!',
  daily_missions_info_ranks_title: '🏅 Rank System',
  daily_missions_info_ranks_line_0: 'Your rank depends on the total XP you collect from missions:',
  daily_missions_info_ranks_line_1: '• Rank F → 0 – 199 XP',
  daily_missions_info_ranks_line_2: '• Rank E → 200 – 699 XP',
  daily_missions_info_ranks_line_3: '• Rank D → 700 – 2,499 XP',
  daily_missions_info_ranks_line_4: '• Rank C → 2,500 – 7,999 XP',
  daily_missions_info_ranks_line_5: '• Rank B → 8,000 – 21,999 XP',
  daily_missions_info_ranks_line_6: '• Rank A → 22,000 – 54,999 XP',
  daily_missions_info_ranks_line_7: '• Rank S → 55,000+ XP',
  daily_missions_info_ranks_line_8: 'Higher ranks unlock new missions and increase your daily energy!',
  daily_missions_mission_daily_react_posts_F_title: 'Beginner Reactor 🔥',
  daily_missions_mission_daily_react_posts_F_desc: 'React to {req} posts today',
  daily_missions_mission_daily_react_posts_F_team_desc: 'Have your team reach {req} post reactions today',
  daily_missions_mission_daily_react_posts_C_title: 'Pro Reactor 🔥',
  daily_missions_mission_daily_react_posts_C_desc: 'React to {req} posts today',
  daily_missions_mission_daily_react_posts_C_team_desc: 'Have your team reach {req} post reactions today',
  daily_missions_mission_daily_react_posts_A_title: 'Legend Reactor 🔥',
  daily_missions_mission_daily_react_posts_A_desc: 'React to {req} posts today',
  daily_missions_mission_daily_react_posts_A_team_desc: 'Have your team reach {req} post reactions today',
  daily_missions_mission_daily_react_comments_F_title: 'Comment Companion 💬',
  daily_missions_mission_daily_react_comments_F_desc: 'React to {req} comments today',
  daily_missions_mission_daily_react_comments_F_team_desc: 'Have your team react to {req} comments today',
  daily_missions_mission_daily_react_comments_C_title: 'Active Comment Reader 💬',
  daily_missions_mission_daily_react_comments_C_desc: 'React to {req} comments today',
  daily_missions_mission_daily_react_comments_C_team_desc: 'Have your team react to {req} comments today',
  daily_missions_mission_daily_react_comments_A_title: 'Comment Master 💬',
  daily_missions_mission_daily_react_comments_A_desc: 'React to {req} comments today',
  daily_missions_mission_daily_react_comments_A_team_desc: 'Have your team react to {req} comments today',
  daily_missions_mission_daily_react_replies_F_title: 'Reply Reactor ↩️',
  daily_missions_mission_daily_react_replies_F_desc: 'React to {req} replies today',
  daily_missions_mission_daily_react_replies_F_team_desc: 'Have your team react to {req} replies today',
  daily_missions_mission_daily_react_replies_C_title: 'Enthusiastic Replier ↩️',
  daily_missions_mission_daily_react_replies_C_desc: 'React to {req} replies today',
  daily_missions_mission_daily_react_replies_C_team_desc: 'Have your team react to {req} replies today',
  daily_missions_mission_daily_react_replies_A_title: 'Reply Prince ↩️',
  daily_missions_mission_daily_react_replies_A_desc: 'React to {req} replies today',
  daily_missions_mission_daily_react_replies_A_team_desc: 'Have your team react to {req} replies today',
  daily_missions_mission_total_react_posts_100_title: 'Post Lover ❤️',
  daily_missions_mission_total_react_posts_100_desc: 'Reach {req} total reactions on posts',
  daily_missions_mission_total_react_posts_100_team_desc: 'Have your team reach {req} total post reactions',
  daily_missions_mission_total_react_comments_50_title: 'Comment Reader 📖',
  daily_missions_mission_total_react_comments_50_desc: 'Reach {req} total reactions on comments',
  daily_missions_mission_total_react_comments_50_team_desc: 'Have your team reach {req} total comment reactions',
  daily_missions_mission_total_react_replies_50_title: 'Reply Lover 💌',
  daily_missions_mission_total_react_replies_50_desc: 'Reach {req} total reactions on replies',
  daily_missions_mission_total_react_replies_50_team_desc: 'Have your team reach {req} total reply reactions',
  daily_missions_mission_daily_posts_F_title: 'Content Maker 📝',
  daily_missions_mission_daily_posts_F_desc: 'Create {req} post today',
  daily_missions_mission_daily_posts_F_team_desc: 'Have your team create {req} post today',
  daily_missions_mission_daily_posts_C_title: 'Active Publisher 🚀',
  daily_missions_mission_daily_posts_C_desc: 'Create {req} posts today',
  daily_missions_mission_daily_posts_C_team_desc: 'Have your team create {req} posts today',
  daily_missions_mission_daily_posts_A_title: 'Content Machine ⚡',
  daily_missions_mission_daily_posts_A_desc: 'Create {req} posts today',
  daily_missions_mission_daily_posts_A_team_desc: 'Have your team create {req} posts today',
  daily_missions_mission_total_posts_10_title: 'Ten Posts ⚔️',
  daily_missions_mission_total_posts_10_desc: 'Publish {req} posts in total',
  daily_missions_mission_total_posts_10_team_desc: 'Have your team publish {req} posts in total',
  daily_missions_mission_total_posts_50_title: 'Pro Blogger 📜',
  daily_missions_mission_total_posts_50_desc: 'Publish {req} posts in total',
  daily_missions_mission_total_posts_50_team_desc: 'Have your team publish {req} posts in total',
  daily_missions_mission_daily_comments_F_title: 'Commenter of the Day 💡',
  daily_missions_mission_daily_comments_F_desc: 'Write {req} comments today',
  daily_missions_mission_daily_comments_F_team_desc: 'Have your team write {req} comments today',
  daily_missions_mission_daily_comments_C_title: 'Experienced Commenter 💡',
  daily_missions_mission_daily_comments_C_desc: 'Write {req} comments today',
  daily_missions_mission_daily_comments_C_team_desc: 'Have your team write {req} comments today',
  daily_missions_mission_daily_comments_A_title: 'Voice of Opinion 🗣️',
  daily_missions_mission_daily_comments_A_desc: 'Write {req} comments today',
  daily_missions_mission_daily_comments_A_team_desc: 'Have your team write {req} comments today',
  daily_missions_mission_total_comments_25_title: 'Opinion Holder 🗣️',
  daily_missions_mission_total_comments_25_desc: 'Write {req} comments in total',
  daily_missions_mission_total_comments_25_team_desc: 'Have your team write {req} comments in total',
  daily_missions_mission_daily_replies_F_title: 'Fast Replier ⚡',
  daily_missions_mission_daily_replies_F_desc: 'Write {req} replies today',
  daily_missions_mission_daily_replies_F_team_desc: 'Have your team write {req} replies today',
  daily_missions_mission_daily_replies_C_title: 'Active Converser ⚡',
  daily_missions_mission_daily_replies_C_desc: 'Write {req} replies today',
  daily_missions_mission_daily_replies_C_team_desc: 'Have your team write {req} replies today',
  daily_missions_mission_daily_replies_A_title: 'Skilled Converser 🎙️',
  daily_missions_mission_daily_replies_A_desc: 'Write {req} replies today',
  daily_missions_mission_daily_replies_A_team_desc: 'Have your team write {req} replies today',
  daily_missions_mission_total_replies_25_title: 'Skilled Converser 🎙️',
  daily_missions_mission_total_replies_25_desc: 'Write {req} replies in total',
  daily_missions_mission_total_replies_25_team_desc: 'Have your team write {req} replies in total',
  daily_missions_mission_daily_tasbeeh_F_title: 'Dhikr of the Day 📿',
  daily_missions_mission_daily_tasbeeh_F_desc: 'Say tasbeeh {req} times today',
  daily_missions_mission_daily_tasbeeh_F_team_desc: 'Have your team say tasbeeh {req} times today',
  daily_missions_mission_daily_tasbeeh_C_title: 'Dedicated Tasbeeh 🌙',
  daily_missions_mission_daily_tasbeeh_C_desc: 'Say tasbeeh {req} times today',
  daily_missions_mission_daily_tasbeeh_C_team_desc: 'Have your team say tasbeeh {req} times today',
  daily_missions_mission_daily_tasbeeh_A_title: 'Master of Dhikr ✨',
  daily_missions_mission_daily_tasbeeh_A_desc: 'Say tasbeeh {req} times today',
  daily_missions_mission_daily_tasbeeh_A_team_desc: 'Have your team say tasbeeh {req} times today',
  daily_missions_mission_total_tasbeeh_1000_title: 'One Thousand Tasbeeh 🏅',
  daily_missions_mission_total_tasbeeh_1000_desc: 'Say tasbeeh {req} times in total',
  daily_missions_mission_total_tasbeeh_1000_team_desc: 'Have your team say tasbeeh {req} times in total',
  daily_missions_mission_adhkar_morning_title: 'Morning Adhkar 🌅',
  daily_missions_mission_adhkar_morning_desc: 'Complete morning adhkar today',
  daily_missions_mission_adhkar_morning_team_desc: 'Complete morning adhkar today',
  daily_missions_mission_adhkar_evening_title: 'Evening Adhkar 🌆',
  daily_missions_mission_adhkar_evening_desc: 'Complete evening adhkar today',
  daily_missions_mission_adhkar_evening_team_desc: 'Complete evening adhkar today',
  daily_missions_mission_adhkar_both_title: 'A Full Day of Dhikr ✨',
  daily_missions_mission_adhkar_both_desc: 'Complete morning and evening adhkar on the same day',
  daily_missions_mission_adhkar_both_team_desc: 'Complete morning and evening adhkar on the same day',
  winners_card_title: 'Adhkar Contest Results',
  winners_card_today: 'Today: {date}',
  winners_card_empty: 'There are no winners for today in the Adhkar contest.',
  winners_card_unknown: 'Unknown',
  winners_card_tasbeeh_count: '{count} tasbeeh',
  winners_card_reward_stars: '{count} stars',
  winners_card_participation: 'Participation',
  winners_card_prize_1: '🥇 1st place: {count} stars + one-day badge certificate',
  winners_card_prize_2: '🥈 2nd place: {count} stars',
  winners_card_prize_3: '🥉 3rd place: {count} stars',
  winners_card_prize_4: '🏅 4th place: {count} stars',
  winners_card_prize_5: '🎖️ 5th place: {count} stars',
  winners_card_prizes_note: 'The top 5 receive prizes; the rest are honorable participants.',
  pack_create_title: 'Create Adhkar Pack',
  pack_edit_title: 'Edit Adhkar Pack',
  pack_status_draft: 'Draft',
  pack_status_published: 'Published',
  pack_saving: 'Saving…',
  pack_title_label: 'Pack title',
  pack_title_placeholder: 'e.g. Morning Adhkar — Hisn al-Muslim',
  pack_description_label: 'Description',
  pack_description_placeholder: 'What makes this pack different (ordering, source, extra duas)?',
  pack_type_label: 'Type',
  pack_type_both: 'Morning & Evening',
  pack_language_label: 'Language',
  pack_language_ar: 'Arabic',
  pack_language_en: 'English',
  pack_language_both: 'Arabic & English',
  pack_scholar_label: 'Scholar (optional)',
  pack_scholar_placeholder: 'e.g. Ibn Baz',
  pack_source_label: 'Source (optional)',
  pack_source_placeholder: 'e.g. Hisn al-Muslim, Sahih al-Bukhari',
  pack_items_title: 'Adhkar in this pack ({count})',
  pack_add_item_title: 'Add dhikr',
  pack_edit_item_title: 'Edit dhikr',
  pack_duplicate_item: 'Duplicate dhikr',
  pack_add_below_item: 'Add dhikr below this',
  pack_untitled_item: 'Untitled dhikr',
  pack_item_time_label: 'This dhikr applies to',
  pack_item_time_both: 'Both',
  pack_item_time_morning: 'Morning only',
  pack_item_time_evening: 'Evening only',
  pack_no_items_yet: 'No adhkar added yet. Tap "Add dhikr" to start.',
  pack_filter_all: 'All',
  pack_filter_no_items: 'No adhkar match this filter.',
  pack_min_items_hint: 'You need at least {count} adhkar to publish.',
  pack_publish: 'Publish pack',
  pack_republish: 'Publish update',
  pack_publishing: 'Publishing…',
  pack_published_title: 'Pack published',
  pack_published_message: 'Your pack is now visible to reviewers and, once verified, to everyone.',
  pack_publish_error_title: 'Cannot publish yet',
  pack_publish_generic_error: 'Something went wrong while publishing. Please try again.',
  pack_missing_title_error: 'Please give your pack a title before publishing.',
  pack_min_items_error: 'You have {current} adhkar — you need at least {count} to publish.',
  pack_first_publish_changelog: 'Initial release',
  pack_browse_btn: 'Community packs',
  pack_browse_title: 'Browse Adhkar packs',
  pack_create_new: 'Create',
  pack_search_placeholder: 'Search by title…',
  pack_sort_popularity: 'Most downloaded',
  pack_sort_rating: 'Top rated',
  pack_sort_recent: 'Recently updated',
  pack_sort_installs: 'Most used now',
  pack_verified_only: 'Verified only',
  pack_verified_label: 'Verified pack',
  pack_no_results: 'No packs found. Be the first to publish one!',
  pack_no_ratings_yet: 'No ratings yet',
  pack_reviews_modal_title: 'User reviews',
  pack_reviews_empty: 'No reviews to show yet',
  pack_reviews_no_comment: 'No comment left',
  pack_anonymous_reviewer: 'User',
  pack_install: 'Install',
  pack_uninstall: 'Uninstall',
  pack_use_this: 'Use this pack',
  pack_currently_active: 'Currently active',
  pack_bookmark: 'Bookmark',
  pack_resume_drafts_title: 'You have earlier drafts',
  pack_resume_drafts_subtitle: 'Continue an existing draft, or start a brand new pack.',
  pack_continue_draft: 'Continue',
  pack_start_new_pack: 'Start a new pack',
  pack_untitled_draft: 'Untitled draft',
  pack_draft_item_count: '{count} adhkar',
  pack_edit_my_pack: 'Edit pack',
  pack_official_title: 'Original Adhkar',
  pack_official_description: "The app's built-in default list",
  pack_installing: 'Installing…',
  pack_rate_button: 'Rate this pack',
  pack_rate_modal_title: 'Rate this pack',
  pack_rate_stars_label: 'Your rating',
  pack_rate_text_label: 'Comment (optional)',
  pack_rate_text_placeholder: 'Share your thoughts on this pack…',
  pack_rate_select_stars_error: 'Please select a star rating first.',
  pack_rate_generic_error: 'Something went wrong while submitting your rating. Please try again.',
  pack_rate_submitting: 'Submitting…',
  pack_rate_submit: 'Submit rating',
  pack_bookmarked_only: 'Bookmarked only',
  pack_bookmarked_empty: "You haven't bookmarked any packs yet.",
  pack_admin_verify: 'Verify pack',
  pack_admin_unverify: 'Unverify pack',
  pack_admin_unverify_confirm_title: 'Unverify this pack?',
  pack_admin_unverify_confirm_message: 'The pack will lose its verified badge and appear to users as unverified. You can verify it again at any time.',
  pack_admin_ban_author: 'Ban pack author',
  pack_admin_delete_pack: 'Delete pack',
  pack_admin_ban_confirm_title: 'Ban this pack\'s author?',
  pack_admin_ban_confirm_message: 'This user will no longer be able to create new Adhkar packs. This does not affect packs they already published.',
  pack_admin_delete_confirm_title: 'Delete this pack?',
  pack_admin_delete_confirm_message: 'The pack will be removed from the store immediately and will no longer be visible to users. Use this for offensive or non-compliant content.',
  pack_publish_editor_forbidden: 'Only the pack\'s author can publish updates. You can edit the content and save it as a draft, and the author will publish it.',
  pack_banned_title: 'Cannot create a pack',
  pack_banned_from_creating: 'You have been banned from creating new Adhkar packs due to prior misuse.',
  pack_delete_item_confirm_title: 'Delete this dhikr?',
  pack_delete_item_confirm_message: 'This cannot be undone once deleted.',
  pack_confirm_delete: 'Delete',
  pack_verification_verified_badge: 'Verified',
  pack_verification_pending_badge: 'Under review',
  pack_editor_role_badge: 'Editor (no publish rights)',
  pack_more_options: 'More options',
  profile_menu_wallet_currencies: 'Wallet currencies',
  comments_external_link_forbidden: 'You do not have permission to post external links in comments or replies.',
};
